import "./UwProduct.scss";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { showToast } from "../../../toastService.js";
import newRequest from "../../../utils/newRequest.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Chip,
  TablePagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import RefreshIcon from "@mui/icons-material/Refresh";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { IoAdd, IoClose } from "react-icons/io5";
import { MdAdd, MdClose, MdDelete, MdEdit, MdOutlinePreview, MdSave } from "react-icons/md";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { GridLoader, ScaleLoader } from "react-spinners";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import TabNavigation from "../../../components/tabNavigation/TabNavigation.jsx";
import { FiSearch } from "react-icons/fi";
import { useTranslation } from 'react-i18next';
import { qilloIconMap, qilloIconOptions } from "../../../utils/iconMapping.js";
import { GoHomeFill } from "react-icons/go";
import { fetchClientsBySearch, formatAmountsToDecimals, formatStringToNumberV2, replaceTags } from "../../../utils/genericFunctions.js";
import { Home } from "lucide-react";


const UwProduct = () => {
  const { t } = useTranslation();
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const navigate = useNavigate();
  const [productData, setProductData] = useState({});
  const { docid } = useParams();
  const [productDocId, setProductDocId] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewEmailContent, setPreviewEmailContent] = useState("");
  const [previewSmsContent, setPreviewSmsContent] = useState("");
  // product fields
  const [prRisknoteSections, setPrRisknoteSections] = useState([]);
  const [prRenewalDays, setPrRenewalDays] = useState([]);
  const [selectedRenewalDay, setSelectedRenewalDay] = useState(null);
  const [prCode, setPrCode] = useState("");
  const [prName, setPrName] = useState("");
  const [prBehaviour, setPrBehaviour] = useState({
    value: "Default",
    label: "Default"
  });

  const [prPeriodType, setPrPeriodType] = useState({
    value: "Normal",
    label: "Normal"
  });
  const [prCategory, setPrCategory] = useState({
    value: "general",
    label: "General"
  });
  const newSmiNameRef = useRef(null);
  const productNameRef = useRef(null);
  const [prCashCarry, setPrCashCarry] = useState("Y");
  const [prOnetime, setPrOnetime] = useState("N");
  const [prEnabled, setPrEnabled] = useState("Y");

  const [prProjectInfo, setPrProjectInfo] = useState("N");
  const [prParticulars, setPrParticulars] = useState("N");
  const [prLimitYn, setPrLimitYn] = useState("N");
  const [prBenefitYn, setPrBenefitYn] = useState("N");
  const [prExpressQuote, setPrExpressQuote] = useState("Y");
  const [prExpressNote, setPrExpressNote] = useState("Y");
  const [prLimits, setPrLimits] = useState([]);
  const [selectedLimit, setSelectedLimit] = useState(null);
  const [prBenefits, setPrBenefits] = useState([]);
  const [selectedBenefit, setSelectedBenefit] = useState(null);
  const [addLimitText, setAddLimitText] = useState("");
  const [addLimitAmount, setAddLimitAmount] = useState("");
  const [addBenefitText, setAddBenefitText] = useState("");
  const [addBenefitAmount, setAddBenefitAmount] = useState("");
  const limitTextRef = useRef(null);
  const limitAmountRef = useRef(null);
  const benefitTextRef = useRef(null);
  const benefitAmountRef = useRef(null);

  const [prMotor, setPrMotor] = useState("N");
  const [prDrcr, setPrDrcr] = useState(null);

  const [termCode, setTermCode] = useState(null);
  const [termName, setTermName] = useState("");
  const [termMinAge, setTermMinAge] = useState(null);
  const [termMaxAge, setTermMaxAge] = useState(null);
  const [termYears, setTermYears] = useState(null);
  const [termLapseGrace, setTermLapseGrace] = useState(null);
  const [termJointType, setTermJointType] = useState(null);
  const [termPaymentFreq, setTermPaymentFreq] = useState(null);
  const [termDeathLevel, setTermDeathLevel] = useState(null);
  const [termRenewable, setTermRenewable] = useState(null);
  const [termEnabled, setTermEnabled] = useState(null);
  const [termMedical, setTermMedical] = useState(null);
  const [termMrCode, setTermMrCode] = useState(null);
  const [termAction, setTermAction] = useState(null);
  const [termMcCode, setTermMcCode] = useState(null);
  const [termScCode, setTermScCode] = useState(null);
  const [termCcCode, setTermCcCode] = useState(null);
  const [termRiderCode, setTermRiderCode] = useState(null);
  const [termRiderTriggerCm, setTermRiderTriggerCm] = useState(null);

  const [termCashValue, setTermCashValue] = useState(null);
  const [termCashValueStart, setTermCashValueStart] = useState(null);
  const [termCashValuePerc, setTermCashValuePerc] = useState(null);

  const [termMoCode, setTermMoCode] = useState(null);

  const [productTerms, setProductTerms] = useState([]);
  const [selectedProductTerm, setSelectedProductTerm] = useState(null);
  const [isProductTermOpen, setIsProductTermOpen] = useState(false);

  const [templates, setTemplates] = useState([]);
  const [templateDays, setTemplateDays] = useState(0);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [categories, setCategories] = useState([]);

  const [prIcon, setPrIcon] = useState(null);
  const [selectedIcon, setSelectedIcon] = useState(null);

  const [numberGenerations, setNumberGenerations] = useState([]);
  const [prNumGenPolicy, setPrNumGenPolicy] = useState(null);
  const [prNumGenClaim, setPrNumGenClaim] = useState(null);
  const [prNumGenEnd, setPrNumGenEnd] = useState(null);
  const [prNumGenGl, setPrNumGenGl] = useState(null);
  const [prNumGenRi, setPrNumGenRi] = useState(null);
  const [prCommCode, setPrCommCode] = useState(null);
  const [prCommtaxCode, setPrCommtaxCode] = useState(null);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
  });
  const [invokedAction, setInvokedAction] = useState("");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [confirmationActiontext, setConfirmationActiontext] = useState("");
  const [jointTypes, setJointTypes] = useState([]);
  const [repTemps, setRepTemps] = useState([]);

  const [periodTypes, setPeriodTypes] = useState([]);
  const [charges, setCharges] = useState([]);
  const [paymentFreqs, setPaymentFreqs] = useState([]);
  const [benefitLevels, setBenefitLevels] = useState([]);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [prAmountType, setPrAmountType] = useState(null);
  const [prJurisdiction, setPrJurisdiction] = useState(null);
  const [prMaxDays, setPrMaxDays] = useState(366);
  const [prGraceDays, setPrGraceDays] = useState(30);
  const [prProrataDays, setPrProrataDays] = useState(366);
  const [prInstDist, setPrInstDist] = useState(null);
  const [prTerritory, setPrTerritory] = useState(null);
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);
  const [reportKey, setReportKey] = useState(null);
  const [reportKeyName, setReportKeyName] = useState(null);
  const [reportOrder, setReportOrder] = useState(null);
  const [reportTitle, setReportTitle] = useState(null);
  const [reportIcon, setReportIcon] = useState(null);
  const [reportDesc, setReportDesc] = useState(null);
  const [reportFileName, setReportFileName] = useState(null);
  const [reportEndpoint, setReportEndpoint] = useState(null);
  const [reportFilePath, setReportFilePath] = useState(null);
  const [reportEnabled, setReportEnabled] = useState(null);
  const [reportFormat, setReportFormat] = useState({
    value: "pdf",
    label: "pdf",
  });
  const [reportTag, setReportTag] = useState(null);
  const [reportFormatChange, setReportFormatChange] = useState("Y");
  const [reportBackground, setReportBackground] = useState("N");
  const [allowedFormats, setAllowedFormats] = useState([
    {
      value: "pdf",
      label: "pdf",
    }, {
      value: "xlsx",
      label: "xlsx",
    }
  ]);

  const [selectedEntity, setSelectedEntity] = useState(null);
  const [selectedEntityCharge, setSelectedEntityCharge] = useState(null);
  const [entityCharges, setEntityCharges] = useState([]);

  const [isNewSmiDialogOpen, setIsNewSmiDialogOpen] = useState(false);
  const [newSmiName, setNewSmiName] = useState(null);
  const [newSmiCover, setNewSmiCover] = useState(null);

  const [currentAction, setCurrentAction] = useState(null);
  const [jurisdictions, setJurisdictions] = useState([]);
  const [distributions, setDistributions] = useState([]);

  const [seletedExpressSmi, setSeletedExpressSmi] = useState(null);
  const [expressSmis, setExpressSmis] = useState([]);

  const [seletedExpressCover, setSeletedExpressCover] = useState(null);
  const [expressCovers, setExpressCovers] = useState([]);

  const [onApprovalOptions, setOnApprovalOptions] = useState([]);

  const fetchJurisdictions = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Jurisdictions", });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setJurisdictions(options);

    } catch (error) {
      console.error("Error fetching jurisdictions :", error);
    }
  };

  const fetchApprovalOptions = async () => {
    try {
      const options = ["None", "Send Risk Note", "Send Risk Note With KYC"].map((val) => ({
        value: val,
        label: val,
      }));
      setOnApprovalOptions(options);
    } catch (error) {
      console.error("Error fetching jurisdictions :", error);
    }
  };

  const fetchExpressSmis = async (productCode) => {
    try {
      const res = await newRequest.post("/uwProduct/getExpressSmis", { exp_pr_code: productCode });
      const formattedData = res.data?.map(row => ({
        ...row,
        exp_default_si: formatAmountsToDecimals(row?.exp_default_si, 2),
        exp_rate: formatAmountsToDecimals(row?.exp_rate, 4),
        exp_rate_per: formatAmountsToDecimals(row?.exp_rate_per, 2),
        exp_fcl_value: formatAmountsToDecimals(row?.exp_fcl_value, 2),
        exp_premium: formatAmountsToDecimals(row?.exp_premium, 2),
        exp_qty: formatAmountsToDecimals(row?.exp_qty, 2),
      }));
      setExpressSmis(formattedData);
    } catch (error) {
      console.error("Error fetching jurisdictions :", error);
    }
  };

  const fetchProductCovers = async (productCode) => {
    try {
      const res = await newRequest.post("/uwProduct/productCovers", { product_code: productCode });
      const options = res.data?.map((row) => ({
        cc_mc_code: row?.cc_mc_code,
        cc_sc_code: row?.cc_sc_code,
        cc_code: row?.cc_code,
        value: row?._id,
        label: row?.cc_name,
      }));
      setExpressCovers(options);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  const fetchEntityCharges = async ({ productCode, endCode, chargeCode }) => {
    try {
      setIsProcessing(true);
      const res = await newRequest.post("/uwProductEndCharge/findEntityCharge", {
        ac_pr_code: productCode,
        ac_end_code: endCode,
        ac_charge_code: chargeCode,
      });
      setEntityCharges(res.data);
      setIsProcessing(false);
    } catch (error) {
      console.error("Error fetching charges:", error);
    }
  };


  const setInsDistributions = async () => {
    try {
      const options = ["Charges On First", "Distribute Evenly"].map((val) => ({
        value: val,
        label: val,
      }));
      setDistributions(options);
    } catch (error) {
      console.error("Error fetching number generations :", error);
    }
  };

  const fetchNumberGenerations = async () => {
    try {
      const res = await newRequest.post("/numGen/findAll", { result_limit: 100 });
      const options = res.data?.map((stage) => ({
        value: stage?.ng_code,
        label: stage?.ng_name,
      }));
      setNumberGenerations(options);
    } catch (error) {
      console.error("Error fetching number generations :", error);
    }
  };

  const fetchTemplates = async () => {
    try {
      const res = await newRequest.post("/emailTemplate/findAll", { tpt_module: "", result_limit: 100000 });
      const options = res.data?.map((row) => ({
        tpt_ref: row?.tpt_ref,
        value: row?._id,
        label: row?.tpt_name,
      }));
      setTemplates(options);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  const setProductCategories = async () => {
    try {
      const options = [
        { value: "General", label: "General" },
        { value: "term life", label: "Term Life" },
        { value: "whole life", label: "Whole Life" },
        { value: "annuity", label: "Annuity" },
      ].map((catg) => ({
        value: catg.value,
        label: catg.label,
      }));
      setCategories(options);
    } catch (error) {
      console.error("Error fetching number generations :", error);
    }
  };


  const fetchJointTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Term Joint Type" });
      const options = res.data?.map((stage) => ({
        value: stage?.sys_code,
        label: stage?.sys_name,
      }));
      setJointTypes(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const fetchReportTemplates = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Report Templates" });
      const options = res.data?.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_name,
      }));
      setRepTemps(options);
    } catch (error) {
      console.error("Error fetching report templates types:", error);
    }
  };


  const fetchPeriodTypes = async () => {
    try {
      const options = ["Normal", "NextDay"].map((val) => ({
        value: val,
        label: val,
      }));
      setPeriodTypes(options);
    } catch (error) {
      console.error("Error fetching report templates types:", error);
    }
  };

  const fetchCharges = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Charges" });
      const options = res.data?.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_name,
      }));
      setCharges(options);
    } catch (error) {
      console.error("Error fetching report templates types:", error);
    }
  };

  const fetchPaymentFreq = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Payment Frequency" });
      const options = res.data?.map((stage) => ({
        value: stage?.sys_code,
        label: stage?.sys_name,
      }));
      setPaymentFreqs(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchBenefitLevel = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Death Benefit Level" });
      const options = res.data?.map((stage) => ({
        value: stage?.sys_code,
        label: stage?.sys_name,
      }));
      setBenefitLevels(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const handleProductTerm = async () => {
    try {

      if (!termCode) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter unique code!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!termYears) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter term period in years!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!termName) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter term name!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (termMinAge === null) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter minimum entry age!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (termMaxAge === null) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter maximum entry age!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (parseFloat(termMinAge) > parseFloat(termMaxAge)) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Minimum entry age ${termMinAge} cannot be greater than Maximum Age ${termMaxAge}. Please rectify!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!termLapseGrace) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter grace period!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!termJointType) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select joint type!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!termPaymentFreq) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select payment frequency!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!termDeathLevel) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select death benefit behavior!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      // if product is term or whole FaLifeRing, default death cover must be defined
      if (["whole life", "term life"].includes(prCategory?.value)) {
        if (!termCcCode) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please select default death benefit cover!`);
          setIsNotifyDialogOpen(true);
          return;
        }
      }

      if (termAction === "new") {
        const res = await newRequest.post(
          "/uwProduct/addTerm",
          {
            pr_code: prCode,
            term_code: termCode,
            term_name: termName,
            term_min_age: termMinAge,
            term_max_age: termMaxAge,
            term_years: termYears,
            term_lapse_grace: termLapseGrace,
            term_joint_type: termJointType?.value,
            term_payment_freq: termPaymentFreq?.value,
            term_death_level: termDeathLevel?.value,
            term_renewable: termRenewable,
            term_enabled: termEnabled,
            term_mc_code: termMcCode,
            term_sc_code: termScCode,
            term_cc_code: termCcCode?.value,
            term_medical: termMedical,
            term_mr_code: termMrCode?.value,
            term_rider_code: termRiderCode?.value,
            term_rider_trigger_cm: termRiderTriggerCm,
            term_cash_value: termCashValue,
            term_cash_value_start: termCashValueStart,
            term_cash_value_perc: termCashValuePerc,
            term_mo_code: termMoCode?.value,
          }
        );

        if (res.data === "exists") {
          showToast(`Term with CODE ${termCode} already exists`, "error");
        } else {
          setSelectedTermData(null);
          setSelectedProductTerm(null);
          setIsProductTermOpen(false);
          fetchProduct();
          showToast(`Term ${termName} added`, "success");
        }
      } else if (termAction === "edit") {
        const res = await newRequest.post(
          "/uwProduct/updateTerm",
          {
            pr_code: prCode,
            term_code: termCode,
            term_name: termName,
            term_min_age: termMinAge,
            term_max_age: termMaxAge,
            term_years: termYears,
            term_lapse_grace: termLapseGrace,
            term_joint_type: termJointType?.value,
            term_payment_freq: termPaymentFreq?.value,
            term_death_level: termDeathLevel?.value,
            term_renewable: termRenewable,
            term_enabled: termEnabled,
            term_mc_code: termMcCode,
            term_sc_code: termScCode,
            term_cc_code: termCcCode?.value,
            term_rider_code: termRiderCode?.value,
            term_rider_trigger_cm: termRiderTriggerCm,
            term_medical: termMedical,
            term_mr_code: termMrCode?.value,
            term_cash_value: termCashValue,
            term_cash_value_start: termCashValueStart,
            term_cash_value_perc: termCashValuePerc,
            term_mo_code: termMoCode?.value,
          }
        );

        // console.log(`updateTerm  ${JSON.stringify(res.data, null, 2)}`);

        if (res.data?.update_status === "updated") {
          // update entire row
          // setProductTerms((prevTerms) => {
          //   // Replace the old term with the updated one
          //   return prevTerms.map((term) =>
          //     term.term_code === termCode
          //       ? res.data?.updated_doc // Replace the old term with the updated document
          //       : term // Return other terms unchanged
          //   );
          // });
          // update field by field
          // setProductTerms((prevTerms) => {
          //   // Map over the existing terms to find and update the matching term
          //   return prevTerms.map((term) =>
          //     term.term_code === termCode
          //       ? {
          //         ...term, // Spread the existing properties
          //         term_name: termName,
          //         term_min_age: termMinAge,
          //         term_max_age: termMaxAge,
          //         term_years: termYears,
          //         term_lapse_grace: termLapseGrace,
          //         term_joint_type: termJointType?.value,
          //         term_payment_freq: termPaymentFreq?.value,
          //         term_death_level: termDeathLevel?.value,
          //         term_renewable: termRenewable,
          //         term_enabled: termEnabled,
          //         term_joint_type_xx: termJointType?.label,
          //         term_payment_freq_xx: termPaymentFreq?.label,
          //         term_death_level_xx: termDeathLevel?.label,
          //       }
          //       : term // Return other terms unchanged
          //   );
          // });
          await fetchProduct(res.data?._id);
          setSelectedTermData(null);
          setSelectedProductTerm(null);
          setIsProductTermOpen(false);
          showToast(`Term ${termName} updated`, "success");
        } else {
          showToast(`Error updating term ${termName} added`, "error");
        }
      }
    } catch (error) {
      console.log(error)
    }
  }


  const setSelectedTermData = async (row) => {
    try {
      if (row) {
        setTermCode(row?.term_code);
        setTermName(row?.term_name);
        setTermMinAge(row?.term_min_age);
        setTermMaxAge(row?.term_max_age);
        setTermYears(row?.term_years);
        setTermLapseGrace(row?.term_lapse_grace);
        setTermMedical(row?.term_medical);
        setTermMrCode({
          value: row?.term_mr_code,
          label: row?.term_mr_code_xx
        });
        setTermMoCode({
          value: row?.term_mo_code,
          label: row?.term_mo_code_xx
        });
        setTermJointType({
          value: row?.term_joint_type,
          label: row?.term_joint_type_xx
        });
        setTermPaymentFreq({
          value: row?.term_payment_freq,
          label: row?.term_payment_freq_xx
        });
        setTermDeathLevel({
          value: row?.term_death_level,
          label: row?.term_death_level_xx
        });
        setTermRenewable(row?.term_renewable);
        setTermEnabled(row?.term_enabled);

        setTermCcCode({
          mc_code: row?.term_mc_code,
          sc_code: row?.term_sc_code,
          value: row?.term_cc_code,
          label: row?.term_cc_code_xx
        });

        setTermRiderCode({
          mc_code: row?.term_mc_code,
          sc_code: row?.term_sc_code,
          value: row?.term_rider_code,
          label: row?.term_rider_code_xx
        });
        setTermRiderTriggerCm(row?.term_rider_trigger_cm);

        setTermMcCode(row?.term_mc_code);
        setTermScCode(row?.term_sc_code);

        setTermCashValue(row?.term_cash_value);
        setTermCashValueStart(row?.term_cash_value_start);
        setTermCashValuePerc(row?.term_cash_value_perc);

      } else {
        setTermCode(null);
        setTermName(null);
        setTermMinAge(0);
        setTermMaxAge(100);
        setTermYears(0);
        setTermLapseGrace(30);
        setTermJointType(null);
        setTermPaymentFreq(null);
        setTermDeathLevel(null);
        setTermMedical("Y");
        setTermMrCode(null);
        setTermMoCode(null);
        setTermRenewable("Y");
        setTermEnabled("Y");
        setTermMcCode(null);
        setTermScCode(null);
        setTermCcCode(null);
        setTermRiderCode(null);
        setTermRiderTriggerCm("N");
        setTermCashValue("N");
        setTermCashValueStart(0);
        setTermCashValuePerc(0);
      }
    } catch (error) {
      console.error("Error setting term data:", error);
    }
  };


  // death benefit cover
  const [selectedDeathCover, setSelectedDeathCover] = useState(null);
  const [deathCovers, setDeathCovers] = useState([]);
  const fetchDeathCovers = async (pr_code) => {
    try {

      const res = await newRequest.post(
        "/uwSubClassCover/findAll",
        {
          cc_mc_code: "",
          cc_sc_code: "",
        }
      );

      const options = res.data?.map((codes) => ({
        mc_code: codes?.cc_mc_code,
        sc_code: codes?.cc_sc_code,
        value: codes?.cc_code,
        label: codes?.cc_name,
      }));

      setDeathCovers(options);
    } catch (error) {
      console.log(error);
    }
  };

  // product excess
  const [newCode, setNewCode] = useState("");
  const [newText, setNewText] = useState("");
  const [excessRowsPerPage, setExcessRowsPerPage] = useState(4);
  const [excessSearchTerm, setExcessSearchTerm] = useState("");
  const [excessPage, setExcessPage] = useState(0);
  const [selectedProductExcess, setSelectedProductExcess] = useState({});
  const [productExcess, setProductExcess] = useState([]);

  const [selectedDocumentType, setSelectedDocumentType] = useState(null);
  const [documentTypes, setDocumentTypes] = useState([]);

  const [excessTypes, setExcessTypes] = useState([]);
  const [limitSearchTerm, setLimitSearchTerm] = useState("");
  const [benefitSearchTerm, setBenefitSearchTerm] = useState("");

  // report templates
  const [reportSearchTerm, setReportSearchTerm] = useState("");
  const [selectedReportTemplate, setSelectedReportTemplate] = useState(null);
  const [reportTemplates, setReportTemplates] = useState([]);

  // product endorsements
  const [endorsementsRowsPerPage, setEndorsementsRowsPerPage] = useState(3);
  const [endorsementsPage, setEndorsementsPage] = useState(0);
  const [selectedProductEnd, setSelectedProductEnd] = useState(null);
  const [productEndorsements, setProductEndorsements] = useState([]);

  const [premiumAmountTypes, setPremiumAmountTypes] = useState([]);
  const [criteriaList, setCriteriaList] = useState([]);
  const [endChargeTypes, setEndChargeTypes] = useState([]);
  const [selectedProductEndCharge, setSelectedProductEndCharge] = useState(null);
  const [productEndCharges, setProductEndCharges] = useState([]);
  const [reportTags, setReportTags] = useState([]);
  const [endChargeBasis, setEndChargeBasis] = useState([]);
  const [behaviourList, setBehaviourList] = useState([]);
  const [selectedEndInternal, setSelectedEndInternal] = useState(null);
  const [endInternalCodes, setEndInternalCodes] = useState([]);
  const [selectedProductSc, setSelectedProductSc] = useState({});
  const [productSc, setProductSc] = useState([]);
  const [isNewConditionOpen, setIsNewConditionOpen] = useState(false);
  const [conditionsRowsPerPage, setConditionsRowsPerPage] = useState(8);
  const [conditionsPage, setConditionsPage] = useState(0);
  const [selectedProductCond, setSelectedProductCond] = useState({});
  const [conditionSearchTerm, setConditionSearchTerm] = useState("");
  const [productConds, setProductConds] = useState([]);
  const [wordingTypes, setWordingTypes] = useState([]);
  const [medicalReviews, setMedicalReviews] = useState([]);
  const [mortalityTables, setMortalityTables] = useState([]);
  const [debitTo, setDebitTo] = useState([]);
  const [scLayouts, setScLayouts] = useState([]);
  const [selectedSubClass, setSelectedSubClass] = useState(null);



  const fetchProductExcess = async (pr_code) => {
    try {
      const res = await newRequest.post("/uwProductExcess/findAll", { ed_pr_code: pr_code });
      setProductExcess(res.data);
      if (res.data) {
        setSelectedProductExcess(res.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleExcessChangePage = (event, newPage) => {
    setExcessPage(newPage);
  };

  const handleExcessChangeRowsPerPage = (event) => {
    setExcessRowsPerPage(parseInt(event.target.value, 4));
    setExcessPage(0);
  };

  const slicedExcessData = productExcess?.slice(
    excessPage * excessRowsPerPage,
    excessPage * excessRowsPerPage + excessRowsPerPage
  );

  const setDocTypes = async () => {
    try {
      const options = ["RiskNote", "Quote", "QuoteRequest", "Policy", "Renewal", "Opportunity"].map((ex) => ({
        value: ex,
        label: ex,
      }));
      setDocumentTypes(options);
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  };

  const fetchProductEndorsements = async (pr_code) => {
    try {
      const res = await newRequest.post("/uwProductEnd/findAll", { pe_pr_code: pr_code });
      setProductEndorsements(res.data);

      if (res.data) {
        setSelectedProductEnd(res.data[0]);
        await fetchProductEndCharges(pr_code, res.data[0]?.pe_end_code);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEndorsementsChangePage = (event, newPage) => {
    setEndorsementsPage(newPage);
  };

  const handleEndorsementsChangeRowsPerPage = (event) => {
    setEndorsementsRowsPerPage(parseInt(event.target.value, 3));
    setEndorsementsPage(0);
  };

  const slicedEndorsementsData = productEndorsements?.slice(
    endorsementsPage * endorsementsRowsPerPage,
    endorsementsPage * endorsementsRowsPerPage + endorsementsRowsPerPage
  );

  const setProductExcessTypes = async () => {
    try {
      const options = ["Si_Percentage", "Premium_Percentage", "Fixed Value", "None"].map((ex) => ({
        value: ex,
        label: ex,
      }));
      setExcessTypes(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const handleNewDedCondition = async () => {
    try {
      if (objectToAction?.new_doc_status === "newCharge") {
        if (!selectedProductEnd) {
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText(`Please select endorsement!`);
          setIsNotifyDialogOpen(true);
          return;
        }
        if (!selectedCharge) {
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText(`Please select charge!`);
          setIsNotifyDialogOpen(true);
          return;
        }
      }

      if (!newText) {
        setNotifyDialogTitle(t('note'));
        setNotifyDialogText(`Please enter name!`);
        setIsNotifyDialogOpen(true);
        return;
      }


      setIsProcessing(true);
      if (objectToAction?.new_doc_status === "newDeductible") {
        const res = await newRequest.post("/uwProductExcess/add", { ed_pr_code: prCode, ed_text: newText });
        setProductExcess((prev) => [...prev, res.data]);
        setIsNewConditionOpen(false);
        setIsProcessing(false);
        setNewText("");
        showToast(t('added'), "success");
      } else if (objectToAction?.new_doc_status === "newCondition") {
        const res = await newRequest.post("/uwProductCond/add", { cond_pr_code: prCode, cond_name: newText });
        setProductConds((prev) => [...prev, res.data]);
        setIsNewConditionOpen(false);
        setIsProcessing(false);
        setNewText("");
        showToast(t('added'), "success");
      } else if (objectToAction?.new_doc_status === "newCharge") {
        const res = await newRequest.post("/uwProductEndCharge/add", {
          ac_pr_code: prCode,
          ac_end_code: selectedProductEnd?.pe_end_code,
          ac_charge_code: newCode,
          ac_charge_name: newText
        });
        setProductEndCharges((prev) => [...prev, res.data.doc]);
        setIsNewConditionOpen(false);
        setIsProcessing(false);
        setNewText("");
        showToast(t('added'), "success");
      }
    } catch (error) {
      console.log(error);
    }
  }

  const fetchProductEndCharges = async (pr_code, end_code) => {
    try {
      const res = await newRequest.post("/uwProductEndCharge/findAll", { ac_pr_code: pr_code, ac_end_code: end_code });
      setProductEndCharges([]);
      setProductEndCharges(res.data);
      if (res.data) {
        setSelectedProductEndCharge(res.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setChargeTypes = async () => {
    try {
      const options = ["Levy", "Charge", "Loading", "Discount", "VAT", "WTAX", "OtherTax"].map((sc) => ({
        value: sc,
        label: sc,
      }));
      setEndChargeTypes(options);
    } catch (error) {
      console.error("Error fetching tax types:", error);
    }
  };


  const setAmountTypes = async () => {
    try {
      const options = ["Net", "Gross"].map((sc) => ({
        value: sc,
        label: sc,
      }));
      setPremiumAmountTypes(options);
    } catch (error) {
      console.error("Error fetching tax types:", error);
    }
  };


  const setCriteria = async () => {
    try {
      const options = ["Default", "Air", "Sea", "Road", "MN-Freq", "QT-Freq", "HY-Freq", "FY-Freq", "LS-Freq"].map((sc) => ({
        value: sc,
        label: sc,
      }));
      setCriteriaList(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchBehaviours = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Internal Product", });
      const options = res.data?.map((sc) => ({
        value: sc?.sys_code,
        label: sc?.sys_name,
      }));
      setBehaviourList(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const fetchReportTags = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Report Tags", });
      const options = res.data?.map((sc) => ({
        value: sc?.sys_code,
        label: sc?.sys_name,
      }));
      setReportTags(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const setChargeBasis = async () => {
    try {
      const options = ["Sum Insured", "Net Premium", "Gross Premium", "Fixed Amount"].map((sc) => ({
        value: sc,
        label: sc,
      }));
      setEndChargeBasis(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const fetchEndInternalCodes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "End Internal Codes", });
      const options = res.data?.map((sc) => ({
        value: sc.sys_code,
        label: sc.sys_name,
      }));
      setEndInternalCodes(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const fetchProductSc = async (pr_code) => {
    try {
      const res = await newRequest.post("/uwProductSc/findAll", {
        ps_pr_code: pr_code,
      });
      setProductSc(res.data);
      if (res.data) {
        setSelectedProductSc(res.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };



  const fetchProductCond = async (pr_code) => {
    try {
      const res = await newRequest.post("/uwProductCond/findAll", {
        cond_pr_code: pr_code,
      });
      setProductConds(res.data);
      if (res.data) {
        setSelectedProductCond(res.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const handleConditionsChangePage = (event, newPage) => {
    setConditionsPage(newPage);
  };
  const handleConditionsChangeRowsPerPage = (event) => {
    setConditionsRowsPerPage(parseInt(event.target.value, 8));
    setConditionsPage(0);
  };
  const slicedConditionsData = productConds?.slice(
    conditionsPage * conditionsRowsPerPage,
    conditionsPage * conditionsRowsPerPage + conditionsRowsPerPage
  );

  const fetchWordingType = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Wording Type" });

      const options = res.data?.map((wt) => ({
        value: wt?.sys_code,
        label: wt?.sys_code,
      }));

      setWordingTypes(options);
    } catch (error) {
      console.error("Error fetching wording types:", error);
    }
  };

  const fetchMedicalReviews = async () => {
    try {
      const res = await newRequest.post("/uwMedicalReview/findAll", { mr_code: "" });
      const options = res.data?.map((codes) => ({
        value: codes?.mr_code,
        label: codes?.mr_name,
      }));
      setMedicalReviews(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchMortalityTables = async () => {
    try {
      const res = await newRequest.get("/uwMortality/search");
      const options = res.data?.map((codes) => ({
        value: codes?.mo_code,
        label: codes?.mo_name,
      }));
      setMortalityTables(options);
    } catch (error) {
      console.error("Error fetching mortality tbles:", error);
    }
  };

  const fetchDebitTo = async () => {
    try {
      const options = ["Insured", "Intermediary"].map((drcr) => ({
        value: drcr,
        label: drcr,
      }));
      setDebitTo(options);
    } catch (error) {
      console.error("Error fetching mortality tbles:", error);
    }
  };

  const fetchScLayouts = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Risk Layout" });
      const options = res.data?.map((sc) => ({
        name: "ps_view",
        type: "select",
        value: sc?.sys_code,
        label: sc?.sys_name,
      }));
      setScLayouts(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchSubClasses = async (inputValue, callback) => {
    try {
      if (inputValue?.length >= 2) {
        const res = await newRequest.post("/uwSubClass/search", { search_input: inputValue });
        const options = res.data?.map((sc) => ({
          sc_mc_code: sc?.sc_mc_code,
          sc_icon: sc?.sc_icon,
          sc_view: sc?.sc_view,
          value: sc?.sc_code,
          label: sc?.sc_enabled === "Y" ? sc.sc_name : `${sc.sc_name} [DISABLED]`,
          isDisabled: sc.sc_enabled !== "Y"
        }));

        callback(options);
      }
    } catch (error) {
      console.error("Error fetching entity types:", error);
      callback([]);
    }
  };

  const handleProductScChange = (newValue, rowId, field) => {
    setProductSc((prevProductSc) =>
      prevProductSc.map((item) =>
        item._id === rowId
          ? { ...item, [field]: newValue, changed_xx: "Y" }
          : item
      )
    );
  };

  const handleProductEndorsements = (value, rowId, field) => {
    setProductEndorsements((prevProductEnds) =>
      prevProductEnds.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };


  const handleExpressSmis = (value, rowId, field) => {
    try {
      const updatedData = [...expressSmis];
      const index = updatedData.findIndex(smi => smi._id === rowId);
      if (index !== -1) {
        // const numberFields = ["exp_default_si", "exp_rate", "exp_rate_per", "exp_premium", "exp_fcl_value", "exp_qty"];
        // if (numberFields.includes(field)) {
        //   updatedData[index][field] = formatStringToNumberV2(value, field === "exp_rate" ? 4 : 2);
        // } else {
        //   updatedData[index][field] = value;
        // }
        updatedData[index][field] = value;
        updatedData[index]["changed_xx"] = "Y";
        setExpressSmis(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleExpressSmisBlur = (id, field) => {
    try {
      const updatedData = [...expressSmis];
      //  console.log(`... updatedData  ${JSON.stringify(updatedData, null, 2)}`);
      const index = updatedData.findIndex(smi => smi._id === id);
      // console.log(`... index  ${JSON.stringify(index, null, 2)}`);

      if (index !== -1) {
        const value = updatedData[index][field];
        // console.log(`field ${field} ... value is ... ${value}`);
        const numberFields = ["exp_default_si", "exp_rate", "exp_rate_per", "exp_premium", "exp_fcl_value", "exp_qty"];
        if (numberFields.includes(field)) {
          updatedData[index][field] = formatAmountsToDecimals(value, field === "exp_rate" ? 4 : 2);
        } else {
          updatedData[index][field] = value;
        }
        updatedData[index]["changed_xx"] = "Y";
        setExpressSmis(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleProductEndChargeChange = (value, rowId, field) => {
    setProductEndCharges((prevProductEndCharge) =>
      prevProductEndCharge.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };

  const handleEntityChargeChange = (value, rowId, field) => {
    setEntityCharges((prevData) =>
      prevData.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };

  const handleProductExcessChange = (value, rowId, field) => {
    setProductExcess((prevProductExcess) =>
      prevProductExcess.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };

  const handleProductLimitChange = (value, rowId, field) => {
    setPrLimits((prev) =>
      prev.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };

  const handleProductBenefitChange = (value, rowId, field) => {
    setPrBenefits((prev) =>
      prev.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };

  const handleProductCondsChange = (value, rowId, field) => {
    setProductConds((prevProductCond) =>
      prevProductCond.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );

    // Update the selectedProductCond state to reflect the changes
    setSelectedProductCond((prevSelected) => {
      if (prevSelected && prevSelected._id === rowId) {
        return { ...prevSelected, [field]: value, changed_xx: "Y" };
      }
      return prevSelected;
    });
  };


  const handleReportTemplateChange = (value, rowId, field) => {
    setReportTemplates((prevData) =>
      prevData.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };


  const saveRecord = async (e) => {
    try {
      setIsProcessing(true);
      // update product details

      if (productDocId === "new") {
        const res = await newRequest.post("/uwProduct/add",
          {
            pr_code: prCode,
            pr_name: prName,
            pr_period_type: prPeriodType?.value,
            pr_category: prCategory?.value,
            pr_cash_carry: prCashCarry,
            pr_onetime: prOnetime,
            pr_enabled: prEnabled,
            pr_motor: prMotor,
            pr_num_gen_policy: prNumGenPolicy?.value,
            pr_num_gen_claim: prNumGenClaim?.value,
            pr_num_gen_end: prNumGenEnd?.value,
            pr_num_gen_gl: prNumGenGl?.value,
            pr_num_gen_ri: prNumGenRi?.value,
            pr_comm_code: prCommCode?.value,
            pr_commtax_code: prCommtaxCode?.value,
            pr_drcr: prDrcr?.value,
            pr_behaviour: prBehaviour?.value,
            pr_amount_type: prAmountType?.value,
            pr_jurisdiction: prJurisdiction?.value,
            pr_territory: prTerritory?.value,
            pr_max_days: prMaxDays || 366,
            pr_grace_days: prGraceDays || 30,
            pr_prorata_days: prProrataDays || 366,
            pr_inst_dist: prInstDist?.value,
          }
        );

        setIsLoading(false);
        setNotifyDialogTitle(t('success'));
        setNotifyDialogText(`${t("successSaved", { param1: res.data?.pr_name })}`);
        setIsNotifyDialogOpen(true);
        setProductDocId(res.data?._id);
        await fetchProduct(res.data?._id);
        navigate(`/product/${res.data?._id}`, { replace: true });
      } else {
        await newRequest.put(
          `/uwProduct/upd/${productDocId}`,
          {
            pr_name: prName,
            pr_period_type: prPeriodType?.value,
            pr_category: prCategory?.value,
            pr_cash_carry: prCashCarry,
            pr_onetime: prOnetime,
            pr_enabled: prEnabled,
            pr_motor: prMotor,
            pr_num_gen_policy: prNumGenPolicy?.value,
            pr_num_gen_claim: prNumGenClaim?.value,
            pr_num_gen_end: prNumGenEnd?.value,
            pr_num_gen_gl: prNumGenGl?.value,
            pr_num_gen_ri: prNumGenRi?.value,
            pr_comm_code: prCommCode?.value,
            pr_commtax_code: prCommtaxCode?.value,
            pr_drcr: prDrcr?.value,
            pr_icon: selectedIcon?.value,
            pr_project_info: prProjectInfo,
            pr_particulars: prParticulars,
            pr_limit_yn: prLimitYn,
            pr_benefit_yn: prBenefitYn,
            pr_limits: prLimits || [],
            pr_benefits: prBenefits || [],
            pr_behaviour: prBehaviour?.value,
            pr_amount_type: prAmountType?.value,
            pr_jurisdiction: prJurisdiction?.value,
            pr_territory: prTerritory?.value,
            pr_risknote_sections: prRisknoteSections || [],
            pr_max_days: prMaxDays || 366,
            pr_grace_days: prGraceDays || 30,
            pr_prorata_days: prProrataDays || 366,
            pr_inst_dist: prInstDist?.value,
            pr_express_quote: prExpressQuote,
            pr_express_note: prExpressNote
          }
        );

        // end of product update
        // update wordings
        const changedWordings = productConds.filter((obj) => obj.changed_xx === "Y");

        // Loop through each object in the array
        for (let i = 0; i < changedWordings.length; i++) {
          await newRequest.put(
            `/uwProductCond/upd/${changedWordings[i]._id}`,
            {
              cond_ref_no: changedWordings[i].cond_ref_no,
              cond_name: changedWordings[i].cond_name,
              cond_desc: changedWordings[i].cond_desc,
              cond_type: changedWordings[i].cond_type,
              cond_order: changedWordings[i].cond_order,
              cond_icon: changedWordings[i].cond_icon,
              cond_mandatory: changedWordings[i].cond_mandatory,
              cond_default: changedWordings[i].cond_default,
              cond_enabled: changedWordings[i].cond_enabled
            }
          );
        }
        // end of update wordings

        // sub classes
        const changedSubClass = productSc.filter((obj) => obj.changed_xx === "Y");

        for (let i = 0; i < changedSubClass.length; i++) {
          await newRequest.put(
            `/uwProductSc/upd/${changedSubClass[i]._id}`,
            {
              ps_view: changedSubClass[i].ps_view,
              ps_default: changedSubClass[i].ps_default,
              ps_enabled: changedSubClass[i].ps_enabled,
              updatedBy: currentUser.usr_id,
            }
          );
        }

        // endorsements
        const changedEndorsements = productEndorsements.filter(
          (obj) => obj.changed_xx === "Y"
        );

        for (let i = 0; i < changedEndorsements.length; i++) {
          await newRequest.put(
            `/uwProductEnd/upd/${changedEndorsements[i]._id}`,
            {
              pe_end_code: changedEndorsements[i]?.pe_end_code,
              pe_desc: changedEndorsements[i]?.pe_desc,
              pe_name: changedEndorsements[i]?.pe_name,
              pe_internal_code: changedEndorsements[i]?.pe_internal_code,
              pe_enabled: changedEndorsements[i]?.pe_enabled,
              pe_email_template: changedEndorsements[i]?.pe_email_template,
              pe_approval_send: changedEndorsements[i]?.pe_approval_send
            }
          );
        }

        // endorsement charges
        const changedEndCharges = productEndCharges.filter((obj) => obj.changed_xx === "Y");

        for (let i = 0; i < changedEndCharges.length; i++) {
          const res = await newRequest.put(
            `/uwProductEndCharge/upd/${changedEndCharges[i]._id}`,
            {
              ac_charge_code: changedEndCharges[i]?.ac_charge_code,
              ac_charge_type: changedEndCharges[i]?.ac_charge_type,
              ac_charge_basis: changedEndCharges[i]?.ac_charge_basis,
              ac_charge_name: changedEndCharges[i]?.ac_charge_name,
              ac_charge_rate: changedEndCharges[i]?.ac_charge_rate,
              ac_charge_rate_per: changedEndCharges[i]?.ac_charge_rate_per,
              ac_criteria: changedEndCharges[i]?.ac_criteria,
              ac_enabled: changedEndCharges[i]?.ac_enabled,
              ac_mandatory: changedEndCharges[i]?.ac_mandatory,
            }
          );
        }

        // product excess
        const changedProductExcess = productExcess.filter(
          (obj) => obj.changed_xx === "Y"
        );

        for (let i = 0; i < changedProductExcess.length; i++) {
          await newRequest.put(
            `/uwProductExcess/upd/${changedProductExcess[i]._id}`,
            {
              ed_text: changedProductExcess[i]?.ed_text,
              ed_max_limit: changedProductExcess[i]?.ed_max_limit,
              ed_mandatory: changedProductExcess[i]?.ed_mandatory,
              ed_enabled: changedProductExcess[i]?.ed_enabled,
              ed_default: changedProductExcess[i]?.ed_default,
              ed_type: changedProductExcess[i]?.ed_type,
              ed_value: changedProductExcess[i]?.ed_value,
              ed_order: changedProductExcess[i]?.ed_order,
            }
          );
        }

        // update report templates
        const changedTemplate = reportTemplates?.filter((obj) => obj.changed_xx === "Y");
        for (let i = 0; i < changedTemplate.length; i++) {
          await newRequest.post("/uwProduct/updateProductTemplate",
            {
              pr_code: prCode,
              report_key: changedTemplate[i].report_key,
              report_order: changedTemplate[i].report_order,
              report_title: changedTemplate[i].report_title,
              report_file_name: changedTemplate[i].report_file_name,
              report_endpoint: changedTemplate[i].report_endpoint
            }
          );
        }

        const changedLimits = prLimits.filter((obj) => obj.changed_xx === "Y");
        for (let i = 0; i < changedLimits.length; i++) {
          await newRequest.post("/uwProduct/updateLimit",
            {
              product_docid: productDocId,
              limit_docid: changedLimits[i]?._id,
              limit_text: changedLimits[i]?.limit_text,
              limit_amount: changedLimits[i]?.limit_amount
            }
          );
        }

        const changedExpressSmi = expressSmis.filter((obj) => obj.changed_xx === "Y");
        for (let i = 0; i < changedExpressSmi.length; i++) {
          await newRequest.put(`/uwProduct/updateExpressSmi/${changedExpressSmi[i]?._id}`,
            {
              exp_order: changedExpressSmi[i]?.exp_order,
              exp_mc_code: changedExpressSmi[i]?.exp_mc_code,
              exp_sc_code: changedExpressSmi[i]?.exp_sc_code,
              exp_cc_code: changedExpressSmi[i]?.exp_cc_code,
              exp_smi_name: changedExpressSmi[i]?.exp_smi_name,
              exp_default_si: formatStringToNumberV2(changedExpressSmi[i]?.exp_default_si),
              exp_rate: formatStringToNumberV2(changedExpressSmi[i]?.exp_rate, 4),
              exp_rate_per: formatStringToNumberV2(changedExpressSmi[i]?.exp_rate_per),
              exp_fcl_value: formatStringToNumberV2(changedExpressSmi[i]?.exp_fcl_value),
              exp_qty: formatStringToNumberV2(changedExpressSmi[i]?.exp_qty),
              exp_add_to_si: changedExpressSmi[i]?.exp_add_to_si,
              exp_enabled: changedExpressSmi[i]?.exp_enabled,
              exp_propagate_si: changedExpressSmi[i]?.exp_propagate_si || [],
            }
          );
        }

        const changedEntityCharges = entityCharges.filter((obj) => obj.changed_xx === "Y");
        for (let i = 0; i < changedEntityCharges.length; i++) {
          await newRequest.put(
            `/uwProductEndCharge/updEntityCharge/${changedEntityCharges[i]._id}`,
            {
              ce_charge_basis: changedEntityCharges[i].ce_charge_basis,
              ce_charge_rate: changedEntityCharges[i].ce_charge_rate,
              ce_charge_rate_per: changedEntityCharges[i].ce_charge_rate_per
            }
          );
        }

      }
      setNotifyDialogTitle(t('note'));
      setNotifyDialogText(t('saved'));
      setIsNotifyDialogOpen(true);
    } catch (error) {
      console.log(error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleReportSubmit = async () => {
    try {


      if (!reportTitle === "000") {
        setNotifyDialogTitle(t('error'));
        setNotifyDialogText("Please enter report title!");
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!selectedDocumentType === "000") {
        setNotifyDialogTitle(t('error'));
        setNotifyDialogText("Please select document type!");
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!reportFileName === "000") {
        setNotifyDialogTitle(t('error'));
        setNotifyDialogText("Please enter report file name!");
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!reportEndpoint === "000") {
        setNotifyDialogTitle(t('error'));
        setNotifyDialogText("Please enter end point!");
        setIsNotifyDialogOpen(true);
        return;
      }

      if (currentAction === "editReport") {
        const res = await newRequest.post("/uwProduct/updateProductTemplate",
          {
            product_docid: productDocId,
            report_docid: selectedReportTemplate?._id,
            report_title: reportTitle,
            report_icon: selectedIcon?.value,
            report_doc_type: selectedDocumentType?.value,
            report_desc: reportDesc,
            report_file_name: reportFileName,
            report_endpoint: reportEndpoint,
            report_file_path: reportFilePath,
            report_format: reportFormat?.value,
            report_format_change: reportFormatChange,
            report_background: reportBackground,
            report_tag: reportTag?.value,
          });

        if (res.data?.msg === "updated") {
          const updatedReport = res.data?.doc;
          setReportTemplates((prevReports) => {
            return prevReports.map((report) =>
              report._id === updatedReport._id ? updatedReport : report
            );
          });
          setIsReportDialogOpen(false);
          showToast(t('updated'), "success");
        } else {
          showToast("Error updating report!", "error");
        }
      } else if (currentAction === "addReport") {
        const res = await newRequest.post("/uwProduct/addProductTemplate",
          {
            product_docid: productDocId,
            report_title: reportTitle,
            report_icon: selectedIcon?.value,
            report_doc_type: selectedDocumentType?.value,
            report_desc: reportDesc,
            report_file_name: reportFileName,
            report_endpoint: reportEndpoint,
            report_file_path: "./assets/$orgCode/reportTemplates",
            report_format: reportFormat?.value,
            report_format_change: reportFormatChange,
            report_background: reportBackground,
            report_tag: reportTag?.value,
          });
        // console.log(`addProductTemplate ${JSON.stringify(res.data, null, 2)}`);
        if (res.data?.msg === "added") {
          setReportTemplates((prevReports) => [...prevReports, res.data?.doc]);
          setIsReportDialogOpen(false);
          showToast(t('added'), "success");
        } else {
          showToast("Error adding report!", "error");
        }
      }
    } catch (error) {
      console.error("Error searching data:", error);
    }
  };

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteSubClass") {
        const res = await newRequest.delete(`/uwProductSc/del/${objectToAction?.object_id}`);
        // console.log(`removeReport  ${JSON.stringify(res.data, null, 2)}`);
        if (res.data === "removed") {
          // Remove from state without re-querying the database
          setProductSc((prevSc) => prevSc.filter(param => param._id !== objectToAction?.object_id));
          setIsConfirmDialogOpen(false);
          showToast(t('removed'), "success");
        } else {
          showToast("Error removing sub class!", "error");
        }
      } else if (confirmDialogAction === "deleteEndoCharge") {
        const res = await newRequest.delete(`/uwProductEndCharge/del/${objectToAction?.object_id}`);
        if (res.data === "deleted") {
          setProductEndCharges((prevSc) =>
            prevSc.filter(param => param._id !== objectToAction?.object_id)
          );
          setIsConfirmDialogOpen(false);
          showToast(t('removed'), "success");
        } else {
          showToast("Error removing sub class!", "error");
        }
      } else if (confirmDialogAction === "deleteReport") {
        const res = await newRequest.post("/uwProduct/removeProductTemplate",
          {
            product_docid: productDocId,
            report_docid: objectToAction?.object_id
          });

        if (res.data?.msg === "removed") {
          setReportTemplates((prevReports) => prevReports.filter(report => report?._id !== res.data.report_docid));
          setSelectedReportTemplate(null);
          setIsConfirmDialogOpen(false);
          showToast(t('deleted'), "success");
        } else {
          showToast("error deleting report!", "error");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };



  const handleToggleChange = (sectionId, newValue) => {
    const updatedSections = prRisknoteSections.map((section) =>
      section?._id === sectionId
        ? { ...section, section_show: newValue }
        : section
    );
    setPrRisknoteSections(updatedSections);
  };


  const fetchProduct = async () => {
    try {

      if (!productDocId || productDocId === undefined) return null;

      setIsLoading(true);

      const res = await newRequest.get(`/uwProduct/findById/${productDocId}`);
      setProductData(res.data);

      if (res.data) {
        setPrCode(res.data?.pr_code);
        setPrName(res.data?.pr_name);

        setPrPeriodType({
          value: res.data?.pr_period_type,
          label: res.data?.pr_period_type
        });

        setPrBehaviour({
          value: res.data?.pr_behaviour,
          label: res.data?.pr_behaviour
        });

        setPrIcon(res.data?.pr_icon);
        const IconComponent = qilloIconMap[res.data?.pr_icon] || GoHomeFill;
        setSelectedIcon({
          value: res.data?.pr_icon,
          label:
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <IconComponent className="icon" /> {res.data?.pr_icon}
            </div>
        });

        if (res.data?.pr_category) {
          setPrCategory({
            value: res.data?.pr_category,
            label: res.data?.pr_category_xx
          });
        }
        setPrCashCarry(res.data?.pr_cash_carry);
        setPrOnetime(res.data?.pr_onetime);
        setPrEnabled(res.data?.pr_enabled);
        setPrMotor(res.data?.pr_motor);
        setPrMaxDays(res.data?.pr_max_days);
        setPrGraceDays(res.data?.pr_grace_days);
        setPrProrataDays(res.data?.pr_prorata_days);
        setPrRisknoteSections(res.data?.pr_risknote_sections);
        setPrRenewalDays(res.data?.pr_renewal_days);
        setProductTerms(res.data?.product_terms_xx);
        setReportTemplates(res.data?.pr_reports);
        if (res.data?.pr_num_gen_policy) {
          setPrNumGenPolicy({
            value: res.data?.pr_num_gen_policy,
            label: res.data?.pr_num_gen_policy_xx,
          });
        }

        if (res.data?.pr_num_gen_claim) {
          setPrNumGenClaim({
            value: res.data?.pr_num_gen_claim,
            label: res.data?.pr_num_gen_claim_xx,
          });
        }

        if (res.data?.pr_num_gen_end) {
          setPrNumGenEnd({
            value: res.data?.pr_num_gen_end,
            label: res.data?.pr_num_gen_end_xx,
          });
        }

        if (res.data?.pr_num_gen_gl) {
          setPrNumGenGl({
            value: res.data?.pr_num_gen_gl,
            label: res.data?.pr_num_gen_gl_xx,
          });
        }

        if (res.data?.pr_num_gen_ri) {
          setPrNumGenRi({
            value: res.data?.pr_num_gen_ri,
            label: res.data?.pr_num_gen_ri_xx,
          });
        }

        if (res.data?.pr_comm_code) {
          setPrCommCode({
            value: res.data?.pr_comm_code,
            label: res.data?.pr_comm_code_xx,
          });
        }

        if (res.data?.pr_commtax_code) {
          setPrCommtaxCode({
            value: res.data?.pr_commtax_code,
            label: res.data?.pr_commtax_code_xx,
          });
        }

        if (res.data?.pr_amount_type) {
          setPrAmountType({
            value: res.data?.pr_amount_type,
            label: res.data?.pr_amount_type,
          });
        }


        if (res.data?.pr_jurisdiction) {
          setPrJurisdiction({
            value: res.data?.pr_jurisdiction,
            label: res.data?.pr_jurisdiction,
          });
        }

        if (res.data?.pr_territory) {
          setPrTerritory({
            value: res.data?.pr_territory,
            label: res.data?.pr_territory,
          });
        }

        if (res.data?.pr_drcr) {
          setPrDrcr({
            value: res.data?.pr_drcr,
            label: res.data?.pr_drcr
          });
        }

        if (res.data?.pr_inst_dist) {
          setPrInstDist({
            value: res.data?.pr_inst_dist,
            label: res.data?.pr_inst_dist,
          });
        }

        setPrProjectInfo(res.data?.pr_project_info);
        setPrParticulars(res.data?.pr_particulars);
        setPrLimitYn(res.data?.pr_limit_yn);
        setPrBenefitYn(res.data?.pr_benefit_yn);
        setPrExpressQuote(res.data?.pr_express_quote);
        setPrExpressNote(res.data?.pr_express_note);

        setPrLimits(res.data?.pr_limits || []);
        setPrBenefits(res.data?.pr_benefits || []);

        await fetchProductExcess(res.data?.pr_code);
        await fetchProductCond(res.data?.pr_code);
        await fetchProductSc(res.data?.pr_code);
        await fetchProductEndorsements(res.data?.pr_code);
        await fetchExpressSmis(res.data?.pr_code);
        await fetchProductCovers(res.data?.pr_code);
      }

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    if (productDocId !== "new") {
      fetchProduct();
    } else {
      if (productNameRef.current) {
        productNameRef.current.focus();
      }
    }
    fetchNumberGenerations();
    fetchScLayouts();
    fetchDebitTo();
    fetchEndInternalCodes();
    fetchReportTemplates();
    setProductCategories();
    setProductExcessTypes();
    setChargeTypes();
    setChargeBasis();
    fetchWordingType();
    fetchCharges();
    fetchPeriodTypes();
    fetchTemplates();
    setCriteria();
    setAmountTypes();
    fetchBehaviours();
    fetchJurisdictions();
    setDocTypes();
    setInsDistributions();
    fetchApprovalOptions();
    fetchReportTags();
  }, [productDocId]);

  const tabs = [
    { tab_index: 0, tab_title: t('endorsements') },
    { tab_index: 1, tab_title: t('applicableClasses') },
    { tab_index: 2, tab_title: t('conditions') },
    { tab_index: 3, tab_title: t('deductiblesExcess') },
    { tab_index: 4, tab_title: t('renewals') },
    { tab_index: 5, tab_title: t('limitsAndBenefits') },
    { tab_index: 6, tab_title: t('screenReports') },
    { tab_index: 7, tab_title: t('expressSmis') }];

  useEffect(() => {
    if (selectedProductEndCharge) {
      fetchEntityCharges({ productCode: selectedProductEndCharge?.ac_pr_code, endCode: selectedProductEndCharge?.ac_end_code, chargeCode: selectedProductEndCharge?.ac_charge_code });
    }
  }, [selectedProductEndCharge]);

  useEffect(() => {
    if (docid) {
      setProductDocId(docid);
    }
  }, [docid]);

  return (
    <motion.div
      className="uw-product"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <div className="product-navbar">
        <div className="product-navbar-left">
          <h1 className="page-title" > {prName?.toUpperCase() || t('new')?.toUpperCase()}</h1>
        </div>
        <div className="product-navbar-right">
          {Object.keys(productData).length > 0 && (
            <CustomLoadingButton
              currentTheme={currentTheme}
              iconPosition="end"
              borderRadiusType="both"
              variant="tint"
              color="#0f766e5d"
              endIcon={<RefreshIcon />}
              onClick={fetchProduct}
            >
              {t('refresh')}
            </CustomLoadingButton>
          )}
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            borderRadiusType="both"
            variant="tint"
            color="#00D37F"
            tooltip="Save changes"
            endIcon={<MdSave />}
            onClick={saveRecord}>
            {t('save')}
          </CustomLoadingButton>
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            borderRadiusType="both"
            variant="tint"
            color="#f55656"
            tooltip="Close this document"
            endIcon={<MdClose />}
            onClick={() => navigate(-1)}>
            {t('close')}
          </CustomLoadingButton>
        </div>
      </div>
      <div className="product-content">
        {isLoading ? (
          <div className="no-content">
            <ScaleLoader
              color="var(--primary)"
              height={50}
              radius={8}
              width={4}
            />
          </div>
        ) : (
          <div className="product-details">
            <ExpandableComponent
              title={t('basicInformation').toUpperCase()}
              subtitle={""}
              defaultExpanded={true}
            >
              <div className="product-details-header">
                <div className="product-details-left">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pr_name"
                      style={{ width: "100px" }}
                    >
                      {t('name').toUpperCase()}
                    </label>
                    <input
                      ref={productNameRef}
                      id="pr_name"
                      name="pr_name"
                      type="text"
                      placeholder={t('name').toUpperCase()}
                      value={prName}
                      className="form-input-item"
                      style={{ width: "400px" }}
                      onChange={(e) => setPrName(e.target.value)}
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="pr_category"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('category').toUpperCase()}
                      </label>
                      <Select
                        id="pr_category"
                        name="pr_category"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="145px"
                        value={prCategory}
                        onChange={(selectedOption) => setPrCategory(selectedOption)}
                        options={categories}
                        isSearchable={true}
                        placeholder={t('select').toUpperCase()}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="pr_period_type"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('periodType').toUpperCase()}
                      </label>
                      <Select
                        id="pr_period_type"
                        name="pr_period_type"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="150px"
                        value={prPeriodType}
                        onChange={(selectedOption) => setPrPeriodType(selectedOption)}
                        options={periodTypes}
                        isSearchable={true}
                        placeholder={t('select').toUpperCase()}
                      />
                    </div>
                  </div>
                  <div className="input-item-with-label">
                    <label htmlFor="pr_drcr" style={{ width: "100px" }}>{t('debit').toUpperCase()}</label>
                    <Select
                      id="pr_drcr"
                      name="pr_drcr"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="400px"
                      value={prDrcr}
                      onChange={(selectedOption) => setPrDrcr(selectedOption)}
                      options={debitTo}
                      isSearchable={true}
                      placeholder={t('select')}
                    />
                  </div>
                  {/* <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", justifyContent: "space-between" }}>
                  sss
                </div> */}
                  <div style={{ display: "flex", paddingLeft: "90px", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                    <span style={{ display: "flex", flex: "1", height: "42px", alignItems: "center" }}>
                      <ToggleSwitch
                        id="prEnabled"
                        value={prEnabled}
                        onChange={setPrEnabled}
                        label={t('enabled').toUpperCase()}
                        labelPosition={"end"}
                        labelWidth={"max-content"}
                      />
                    </span>
                    <span style={{ display: "flex", flex: "1", height: "42px", alignItems: "center" }}>
                      <ToggleSwitch
                        id="prCashCarry"
                        value={prCashCarry}
                        onChange={setPrCashCarry}
                        label={t('cashAndCarry').toUpperCase()}
                        labelPosition={"end"}
                        labelWidth={"max-content"} />
                    </span>
                  </div>
                  <div style={{ display: "flex", paddingLeft: "90px", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                    <span style={{ display: "flex", flex: "1", height: "42px", alignItems: "center" }}>
                      <ToggleSwitch
                        id="prMotor"
                        value={prMotor}
                        onChange={setPrMotor}
                        label={t('motor').toUpperCase()}
                        labelPosition={"end"}
                        labelWidth={"max-content"}
                      />
                    </span>
                    <span style={{ display: "flex", flex: "1", height: "42px", alignItems: "center" }}>
                      <ToggleSwitch
                        id="prBenefitYn"
                        value={prBenefitYn}
                        onChange={setPrBenefitYn}
                        label={t('showBenefits').toUpperCase()}
                        labelPosition={"end"}
                        labelWidth={"max-content"}
                      />
                    </span>
                  </div>

                  <div style={{ display: "flex", paddingLeft: "90px", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                    <span style={{ display: "flex", flex: "1", height: "42px", alignItems: "center" }}>
                      <ToggleSwitch
                        id="prOnetime"
                        value={prOnetime}
                        onChange={setPrOnetime}
                        label={t('onetime').toUpperCase()}
                        labelPosition={"end"}
                        labelWidth={"max-content"}
                      />
                    </span>
                    <span style={{ display: "flex", flex: "1", height: "42px", alignItems: "center" }}>
                      <ToggleSwitch
                        id="prLimitYn"
                        value={prLimitYn}
                        onChange={setPrLimitYn}
                        label={t('showLimits').toUpperCase()}
                        labelPosition={"end"}
                        labelWidth={"max-content"}
                      />
                    </span>
                  </div>
                  <div style={{ display: "flex", paddingLeft: "90px", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                    <span style={{ display: "flex", flex: "1", height: "42px", alignItems: "center" }}>
                      <ToggleSwitch
                        id="prProjectInfo"
                        value={prProjectInfo}
                        onChange={setPrProjectInfo}
                        label={t('showProjectInfo').toUpperCase()}
                        labelPosition={"end"}
                        labelWidth={"max-content"}
                      />
                    </span>
                  </div>
                  <div style={{ display: "flex", paddingLeft: "90px", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                    <span style={{ display: "flex", flex: "1", height: "42px", alignItems: "center" }}>
                      <ToggleSwitch
                        id="prExpressQuote"
                        value={prExpressQuote}
                        onChange={setPrExpressQuote}
                        label={t('expressQuote').toUpperCase()}
                        labelPosition={"end"}
                        labelWidth={"max-content"}
                      />
                    </span>
                    <span style={{ display: "flex", flex: "1", height: "42px", alignItems: "center" }}>
                      <ToggleSwitch
                        id="prExpressNote"
                        value={prExpressNote}
                        onChange={setPrExpressNote}
                        label={t('expressNote').toUpperCase()}
                        labelPosition={"end"}
                        labelWidth={"max-content"}
                      />
                    </span>
                  </div>
                </div>
                <div className="product-details-right" >
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pr_code"
                      style={{
                        width: "100px",
                      }}
                    >
                      {t('code').toUpperCase()}
                    </label>
                    <input
                      id="pr_code"
                      name="pr_code"
                      type="text"
                      placeholder={t('code').toUpperCase()}
                      value={prCode}
                      disabled={productDocId !== "new"}
                      className="form-input-item"
                      style={{ width: "200px" }}
                      onChange={(e) => setPrCode(e.target.value)}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pr_comm_code"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('commCode').toUpperCase()}
                    </label>
                    <Select
                      id="pr_comm_code"
                      name="pr_comm_code"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="200px"
                      value={prCommCode}
                      onChange={(selectedOption) => setPrCommCode(selectedOption)}
                      options={charges}
                      isSearchable={true}
                      placeholder={t('select').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label htmlFor="pr_commtax_code"
                      style={{ width: "100px" }}>{t('taxCode').toUpperCase()}</label>
                    <Select
                      id="pr_commtax_code"
                      name="pr_commtax_code"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="200px"
                      value={prCommtaxCode}
                      onChange={(selectedOption) => setPrCommtaxCode(selectedOption)}
                      options={charges}
                      isSearchable={true}
                      placeholder={t('select').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label htmlFor="pr_behaviour" style={{ width: "100px" }}>{t('internal').toUpperCase()}</label>
                    <Select
                      id="pr_behaviour"
                      name="pr_behaviour"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="200px"
                      value={prBehaviour}
                      onChange={(selectedOption) => setPrBehaviour(selectedOption)}
                      options={behaviourList}
                      isSearchable={true}
                      placeholder={t('internal').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="icon_select"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('icon').toUpperCase()}
                    </label>
                    <Select
                      id="icon_select"
                      name="icon_select"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      options={qilloIconOptions}
                      width="200px"
                      isSearchable={true}
                      placeholder={t('icon').toUpperCase()}
                      value={selectedIcon}
                      onChange={setSelectedIcon}
                      getOptionLabel={(e) => (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          {e.icon} {e.label}
                        </div>
                      )}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pr_jurisdiction"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('jurisdiction').toUpperCase()}
                    </label>
                    <Select
                      id="pr_jurisdiction"
                      name="pr_jurisdiction"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="200px"
                      value={prJurisdiction}
                      onChange={(selectedOption) => setPrJurisdiction(selectedOption)}
                      options={jurisdictions}
                      isSearchable={true}
                      placeholder={t('jurisdiction').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pr_territory"
                      className="form-dropdown-label"
                      style={{
                        width: "100px",
                      }}
                    >
                      {t('territory').toUpperCase()}
                    </label>
                    <Select
                      id="pr_territory"
                      name="pr_territory"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="200px"
                      value={prTerritory}
                      onChange={(selectedOption) => setPrTerritory(selectedOption)}
                      options={jurisdictions}
                      isSearchable={true}
                      placeholder={t('territory').toUpperCase()}
                    />
                  </div>
                </div>

                <div className="product-details-right">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pr_amount_type"
                      className="form-dropdown-label"
                      style={{
                        width: "100px",
                      }}
                    >
                      {t('amount').toUpperCase()}
                    </label>
                    <Select
                      id="pr_amount_type"
                      name="pr_amount_type"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="200px"
                      value={prAmountType}
                      onChange={(selectedOption) => setPrAmountType(selectedOption)}
                      options={premiumAmountTypes}
                      isSearchable={true}
                      placeholder={t('select').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label htmlFor="pr_inst_dist" style={{ width: "100px" }}>{t('installments').toUpperCase()}</label>
                    <Select
                      id="pr_inst_dist"
                      name="pr_inst_dist"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="200px"
                      value={prInstDist}
                      onChange={(selectedOption) => setPrInstDist(selectedOption)}
                      options={distributions}
                      placeholder={t('select').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label" style={{ alignSelf: "flex-end" }}>
                    <label
                      htmlFor="pr_grace_days"
                      style={{ width: "max-content" }}
                    >
                      {t('gracePeriodDays').toUpperCase()}
                    </label>
                    <input
                      id="pr_grace_days"
                      name="pr_grace_days"
                      type="number"
                      placeholder="0"
                      value={prGraceDays}
                      className="form-input-item"
                      style={{ width: "60px", textAlign: "right" }}
                      onChange={(e) => setPrGraceDays(e.target.value)}
                    />
                  </div>
                  <div className="input-item-with-label" style={{ alignSelf: "flex-end" }}>
                    <label
                      htmlFor="pr_prorata_days"
                      style={{ width: "max-content" }}
                    >
                      {t('prorataPeriodDays').toUpperCase()}
                    </label>
                    <input
                      id="pr_prorata_days"
                      name="pr_prorata_days"
                      type="number"
                      placeholder="0"
                      value={prProrataDays}
                      className="form-input-item"
                      style={{ width: "60px", textAlign: "right" }}
                      onChange={(e) => setPrProrataDays(e.target.value)}
                    />
                  </div>
                  <div className="input-item-with-label" style={{ alignSelf: "flex-end" }}>
                    <label
                      htmlFor="pr_max_days"
                      style={{ width: "max-content" }}
                    >
                      {t('maxDays').toUpperCase()}
                    </label>
                    <input
                      id="pr_max_days"
                      name="pr_max_days"
                      type="number"
                      placeholder="0"
                      value={prMaxDays}
                      className="form-input-item"
                      style={{ width: "60px", textAlign: "right" }}
                      onChange={(e) => setPrMaxDays(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </ExpandableComponent>
            {/* Term Life Section */}
            {prCategory?.value === "term life" &&
              <div className="term-life-section">
                {/* <hr className="separator-h" style={{ marginBottom: "20px" }} /> */}
                <ExpandableComponent
                  title={t('applicableTerms').toUpperCase()}
                  subtitle={
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#43A047"
                      tooltip={`Add new term to ${prName}`}
                      endIcon={<AddIcon />}
                      onClick={async () => {
                        try {
                          await fetchJointTypes();
                          await fetchPaymentFreq();
                          await fetchBenefitLevel();
                          await fetchDeathCovers();
                          await fetchMedicalReviews();
                          await fetchMortalityTables();
                          setTermAction("new");
                          setSelectedTermData(null);
                          setSelectedProductTerm(null);
                          setIsProductTermOpen(true);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      {t('newTerm').toUpperCase()}
                    </CustomLoadingButton>
                  }
                  onSubtitleClick={() => { }}
                  defaultExpanded={true}
                >
                  <div className="term-life-wrapper">
                    <div className="table-content">
                      <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                        <Table sx={{ width: "max-content", border: 'none' }}>
                          {/* <TableHead className="tablehead">
                              <TableRow className="tablerow">
                                <TableCell className="table-cell" style={{ maxWidth: "50px", fontWeight: "bold", display: "flex", alignItems: "center", }}>
                                  #
                                </TableCell>
                                <TableCell className="table-cell" style={{ fontWeight: "bold", width: "auto", display: 'flex' }}>
                                  <span>DETAILS</span>
                                </TableCell>
                                {["admin", "superadmin"].includes(currentUser.user_type_xx) && <TableCell className="table-cell" style={{ fontWeight: "bold", alignItems: "center", display: 'flex', maxWidth: "100px", justifyContent: "center" }}>
                                  <span>ACTION</span>
                                </TableCell>}
                              </TableRow>
                            </TableHead> */}
                          <TableBody className="tablebody">
                            {productTerms?.map((row, index) => (
                              <TableRow
                                key={row._id}
                                className={`${selectedProductTerm?._id === row._id ? "tablerow current" : "tablerow"}`}
                                onClick={() => setSelectedProductTerm(row)}
                              >
                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                  {index + 1}
                                </TableCell>
                                <TableCell className="table-cell left" style={{ width: "auto", flexDirection: "column" }}>
                                  <ExpandableComponent
                                    title={row?.term_name}
                                    subtitle={row?.term_code}
                                    defaultExpanded={false}
                                  >
                                    <div className="product-term-wrapper">
                                      <span className="section-sub-title" style={{ flex: "1", }}>{`ENTRY AGE MIN ${row?.term_min_age} - MAX ${row?.term_max_age}`}</span>
                                      <span className="section-sub-title" style={{ flex: "1", textAlign: "right" }}>{`MEDICAL ${row?.term_medical_xx}`}</span>
                                      <span className="section-sub-title" style={{ flex: "1", textAlign: "right" }}>{`${row?.term_years} YEARS`}</span>
                                    </div>
                                    <div className="product-term-wrapper">
                                      <span className="section-sub-title" style={{ flex: "1" }}>{`GRACE PERIOD ${row?.term_lapse_grace} DAYS`}</span>
                                      <span className="section-sub-title" style={{ flex: "1", textAlign: "right" }}>{row?.term_mr_code_xx}</span>
                                      <span className="section-sub-title" style={{ flex: "1", textAlign: "right" }}>{`RENEWABLE ${row?.term_renewable_xx}`}</span>
                                    </div>
                                    <div className="product-term-wrapper">
                                      <span className="section-sub-title" style={{ flex: "1" }}>{`DEATH BENEFIT TYPE ${row?.term_death_level_xx}`}</span>
                                      <span className="section-sub-title" style={{ flex: "1", textAlign: "right" }}>{`PAYMENT FREQUENCY ${row?.term_payment_freq_xx}`}</span>
                                      <span className="section-sub-title" style={{ flex: "1", textAlign: "right" }}>{`JOINT TYPE ${row?.term_joint_type_xx}`}</span>
                                    </div>
                                    <span className="product-term-desc">{row?.term_desc_xx}</span>
                                  </ExpandableComponent>
                                </TableCell>
                                {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                  <TableCell className="table-cell" style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: 'space-around', padding: "3px", maxWidth: "100px", }}>
                                    <CircularButton
                                      currentTheme={currentTheme}
                                      color="#43A047"
                                      icon={<MdEdit />}
                                      width={"30px"}
                                      height={"30px"}
                                      onClick={async () => {
                                        try {
                                          setSelectedTermData(row);
                                          await fetchJointTypes();
                                          await fetchPaymentFreq();
                                          await fetchBenefitLevel();
                                          await fetchDeathCovers();
                                          await fetchMedicalReviews();
                                          await fetchMortalityTables();
                                          setTermAction("edit");
                                          setSelectedProductTerm(row);
                                          setIsProductTermOpen(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }} />
                                    <CircularButton
                                      currentTheme={currentTheme}
                                      onClick={() => {
                                        try {
                                          setObjectToAction({
                                            object_id: row._id,
                                            action_text: `${t('delete')} ${row?.term_name}?`,
                                            new_doc_status: "deleteNumGen",
                                          });
                                          setConfirmationActiontext(`${t('delete')} ${row?.term_name}?`);
                                          setConfirmDialogAction("deleteNumGen");
                                          setIsConfirmDialogOpen(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                      color="#D32F2F"
                                      icon={<MdDelete />}
                                      width={"30px"}
                                      height={"30px"} />
                                  </TableCell>}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </ExpandableComponent>
              </div>}
            {!["term life", "whole life", "annuity"].includes(prCategory?.value) && <span style={{ height: "10px" }} />}
            {/* Whole Life Section */}
            {prCategory?.value === "whole life" &&
              <div className="whole-life-section">
                <hr className="separator-h" />
                <h1 className="main-title">{t('applicableTerms').toUpperCase()}</h1>
                <div className="whole-life-wrapper">
                  whole-life-wrapper
                </div>
              </div>}
            {/* Annuity Life Section */}
            {prCategory?.value === "annuity" &&
              <div className="annuity-section">
                <hr className="separator-h" />
                <h1 className="main-title">{t('applicableTerms').toUpperCase()}</h1>
                <div className="annuity-wrapper">
                  annuity-wrapper
                </div>
              </div>}
            <TabNavigation tabs={tabs} >
              <div className="endorsements-section">
                {/* <div className="endorsements-toolbar">endorsements-toolbar</div> */}
                <div className="endorsements-wrapper">
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                              <span>{t('code').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                              <span>{t('name').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                              <span>{t('internal').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                              <span>{t('status').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                              <span>{t('enabled').toUpperCase()}</span>
                            </TableCell>
                            {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <span>{t('action').toUpperCase()}</span>
                              </TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {slicedEndorsementsData?.map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className={`${selectedProductEnd?._id === row._id ? "tablerow current" : "tablerow"}`}
                              onClick={async () => {
                                try {
                                  await fetchProductEndCharges(row?.pe_pr_code, row.pe_end_code);
                                  setSelectedProductEnd(row);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                <h1 className="normal-title">{endorsementsPage * endorsementsRowsPerPage + index + 1}</h1>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                <h1 className="sub-title">{row?.pe_end_code}</h1>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto", gap: "5px" }}>
                                {row?.pe_internal_code === "000" ?
                                  <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "5px" }}>
                                    <h1 className="sub-title">{row?.pe_name}</h1>
                                    <h1 className="sub-title">{row?.pe_desc}</h1>
                                  </div>
                                  :
                                  <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "5px" }}>
                                    <div className="input-item-with-label" style={{ width: "100%" }}>
                                      <input
                                        id="pe_name"
                                        name="pe_name"
                                        type="text"
                                        value={row?.pe_name}
                                        placeholder="Name"
                                        style={{ width: "100%" }}
                                        className="form-input-item table"
                                        onChange={(e) => handleProductEndorsements(e.target.value, row._id, "pe_name")}
                                        disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                      />
                                    </div>
                                    <div className="input-item-with-label" style={{ width: "100%" }}>
                                      <textarea
                                        id="pe_desc"
                                        name="pe_desc"
                                        type="text"
                                        rows={2}
                                        value={row?.pe_desc}
                                        placeholder={t('description')}
                                        style={{ width: "100%" }}
                                        className="form-input-item table"
                                        onChange={(e) => handleProductEndorsements(e.target.value, row._id, "pe_desc")}
                                        disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                      />
                                    </div>
                                  </div>}
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <Select
                                    id="pe_email_template"
                                    name="pe_email_template"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="100%"
                                    height="32px"
                                    dropdownHeight={3 * 42}
                                    value={templates.find((option) => option.tpt_ref === row?.pe_email_template) || null}
                                    onChange={(selectedOption) => handleProductEndorsements(selectedOption?.tpt_ref, row._id, "pe_email_template")}
                                    options={templates}
                                    isClearable
                                    isSearchable={true}
                                    placeholder={`${t('emailTemplate')}`}
                                  />
                                </div>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <Select
                                    id="pe_approval_send"
                                    name="pe_approval_send"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="100%"
                                    height="32px"
                                    dropdownHeight={3 * 42}
                                    value={onApprovalOptions.find((option) => option.value === row?.pe_approval_send) || null}
                                    onChange={(selectedOption) => handleProductEndorsements(selectedOption?.value, row._id, "pe_approval_send")}
                                    options={onApprovalOptions}
                                    isSearchable={true}
                                    placeholder={`${t('onApproval')}`}
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <h1 className="sub-title">{row?.pe_internal_code}</h1>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                <div className="cover-chips" style={{ gap: "10px" }}>
                                  {row.pe_policy_status.map((psts) => (
                                    <Chip key={psts} label={psts} />
                                  ))}
                                </div>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                <ToggleSwitch
                                  id={row._id}
                                  value={row?.pe_enabled}
                                  onChange={(newValue) => handleProductEndorsements(newValue, row._id, "pe_enabled")}
                                  label=""
                                  labelPosition="end"
                                  labelWidth="max-content"
                                  border="N"
                                  disabled={row?.pe_internal_code === "000"}
                                />
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={() => {
                                      try {
                                        if (row?.pe_internal_code === "000") {
                                          setNotifyDialogTitle("Note!");
                                          setNotifyDialogText(`You CANNOT remove this record!`);
                                          setIsNotifyDialogOpen(true);
                                          return;
                                        }

                                        setObjectToAction({
                                          object_id: row._id,
                                          action_text: `Delete ${row?.pe_name}?`,
                                          new_doc_status: "deleteEndorsement",
                                        });
                                        setConfirmationActiontext(`Delete ${row?.pe_name}?`);
                                        setConfirmDialogAction("deleteEndorsement");
                                        setIsConfirmDialogOpen(true);
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    disabled={row?.pe_internal_code === "000"}
                                    color="#E53935"
                                    icon={<MdDelete />}
                                    width={"30px"}
                                    height={"30px"} />
                                </TableCell>}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[3]}
                        rowsPerPage={endorsementsRowsPerPage}
                        onRowsPerPageChange={handleEndorsementsChangeRowsPerPage}
                        component="div"
                        count={productEndorsements.length}
                        page={endorsementsPage}
                        onPageChange={handleEndorsementsChangePage}
                      />
                    </TableContainer>
                  </div>
                </div>
                <hr className="separator-h" />
                <div className="endorsements-toolbar">
                  <div style={{ display: "flex", flex: "2", width: "100%", marginTop: "10px", flexDirection: "column", gap: "3px" }}>
                    <span className="main-title" >{t('endApplCharges', { param1: selectedProductEnd?.pe_name })}</span>
                    <span className="sub-title soft" style={{ fontSize: "10px" }}>{t('oneVatText')}</span>
                  </div>
                  <span style={{ display: "flex", flex: "1", justifyContent: "flex-end" }}>
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#26A69A"
                      endIcon={<IoAdd />}
                      onClick={() => {
                        try {
                          setObjectToAction({
                            object_id: "",
                            action_text: "",
                            new_doc_status: "newCharge",
                          });

                          setIsNewConditionOpen(true);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      {t('addCharge')}
                    </CustomLoadingButton>
                  </span>
                </div>
                <div className="endorsements-wrapper" style={{ marginBottom: "5px" }}>
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                              <span>{t('name').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "130px" }}>
                              <span>{t('criteria').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "130px" }}>
                              <span>{t('type').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                              <span>{t('basis').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                              <span>{t('rate').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                              <span>{t('ratePer').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                              <span>{t('enabled').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                              <span>{t('must').toUpperCase()}</span>
                            </TableCell>
                            {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                              <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                <span>{t('action').toUpperCase()}</span>
                              </TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {productEndCharges?.map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className={`${selectedProductEndCharge?._id === row._id ? "tablerow current" : "tablerow"}`}
                              onClick={async () => setSelectedProductEndCharge(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                {index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto" }}>
                                <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                  <span className="sub-title">{row?.ac_charge_name}</span>
                                  <span className="sub-title soft" style={{ fontSize: "10px" }}>{row?.ac_charge_code}</span>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "130px" }}>
                                <Select
                                  id="ac_criteria"
                                  name="ac_criteria"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="120px"
                                  height="32px"
                                  dropdownHeight={3 * 42}
                                  value={criteriaList.find((option) => option.value === row?.ac_criteria) || null}
                                  onChange={(selectedOption) => handleProductEndChargeChange(selectedOption?.value, row._id, "ac_criteria")}
                                  options={criteriaList}
                                  // isSearchable={true}
                                  placeholder="Type"
                                />
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "130px" }}>
                                <Select
                                  id="ac_charge_type"
                                  name="ac_charge_type"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="120px"
                                  height="32px"
                                  dropdownHeight={3 * 42}
                                  value={endChargeTypes.find((option) => option.value === row?.ac_charge_type) || null}
                                  onChange={(selectedOption) => handleProductEndChargeChange(selectedOption?.value, row._id, "ac_charge_type")}
                                  options={endChargeTypes}
                                  // isSearchable={true}
                                  placeholder="Type"
                                />
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                                <Select
                                  id="ac_charge_basis"
                                  name="ac_charge_basis"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="175px"
                                  height="32px"
                                  dropdownHeight={3 * 42}
                                  value={endChargeBasis.find((option) => option.value === row?.ac_charge_basis) || null}
                                  onChange={(selectedOption) => handleProductEndChargeChange(selectedOption?.value, row._id, "ac_charge_basis")}
                                  options={endChargeBasis}
                                  // isSearchable={true}
                                  placeholder={`${t('basis')}`}
                                />
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id="ac_charge_rate"
                                    name="ac_charge_rate"
                                    type="text"
                                    value={row?.ac_charge_rate}
                                    placeholder="0.00"
                                    style={{ width: "100%", textAlign: "right" }}
                                    className="form-input-item table"
                                    onChange={(e) => handleProductEndChargeChange(e.target.value, row._id, "ac_charge_rate")}
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id="ac_charge_rate_per"
                                    name="ac_charge_rate_per"
                                    type="text"
                                    value={row?.ac_charge_rate_per}
                                    placeholder="0.00"
                                    style={{ width: "100%", textAlign: "right" }}
                                    className="form-input-item table"
                                    onChange={(e) => handleProductEndChargeChange(e.target.value, row._id, "ac_charge_rate_per")}
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx) || row?.ac_charge_basis === "Fixed Amount"}
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                <ToggleSwitch
                                  id={row._id}
                                  value={row.ac_enabled}
                                  onChange={(newValue) => handleProductEndChargeChange(newValue, row._id, "ac_enabled")}
                                  label=""
                                  labelPosition="end"
                                  labelWidth="max-content"
                                  border="N"
                                />
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                <ToggleSwitch
                                  id={row._id}
                                  value={row.ac_mandatory}
                                  onChange={(newValue) => handleProductEndChargeChange(newValue, row._id, "ac_mandatory")}
                                  label=""
                                  labelPosition="end"
                                  labelWidth="max-content"
                                  border="N"
                                />
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={() => {
                                      try {
                                        setObjectToAction({
                                          object_id: row._id,
                                          action_text: `Delete ${row?.ac_charge_name}?`,
                                          new_doc_status: "deleteEndoCharge",
                                        });
                                        setConfirmationActiontext(`Delete ${row?.ac_charge_name}?`);
                                        setConfirmDialogAction("deleteEndoCharge");
                                        setIsConfirmDialogOpen(true);
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    color="#E53935"
                                    icon={<MdDelete />}
                                    width={"30px"}
                                    height={"30px"} />
                                </TableCell>}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>

                <div className="endorsements-toolbar">
                  <div style={{ display: "flex", flex: "2", width: "100%", marginTop: "10px", flexDirection: "column", gap: "3px" }}>
                    <span className="main-title" >{t('overridentEntity', { param1: `${selectedProductEndCharge?.ac_charge_name} : ${selectedProductEndCharge?.ac_charge_code}` })}</span>
                    <span className="sub-title soft" style={{ fontSize: "10px" }}>{t('overrideChargeRate')}</span>
                  </div>
                  <span style={{ display: "flex", flex: "1", justifyContent: "flex-end" }}>
                    <div className="input-item-with-label" style={{ display: "flex", gap: "10px" }}>
                      <AsyncSelect
                        id="selectedEntity"
                        name="selectedEntity"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="350px"
                        value={selectedEntity}
                        onChange={(selectedOption) => setSelectedEntity(selectedOption)}
                        loadOptions={fetchClientsBySearch}
                        isSearchable={true}
                        placeholder={t('entity').toUpperCase()}
                        noOptionsMessage={() => "Type Minimum 2 Letter to Search"}
                      />
                      <CircularButton
                        currentTheme={currentTheme}
                        onClick={async (e) => {
                          try {

                            if (!selectedProductEndCharge) {
                              setNotifyDialogTitle(t('note'));
                              setNotifyDialogText(`Charge must be selected`);
                              setIsNotifyDialogOpen(true);
                              return;
                            }

                            if (!selectedEntity) {
                              setNotifyDialogTitle(t('note'));
                              setNotifyDialogText(`Please select entity`);
                              setIsNotifyDialogOpen(true);
                              return;
                            }

                            const res = await newRequest.post(
                              "/uwProductEndCharge/addEntityCharge",
                              {
                                ce_pr_code: selectedProductEndCharge?.ac_pr_code,
                                ce_end_code: selectedProductEndCharge?.ac_end_code,
                                ce_charge_code: selectedProductEndCharge?.ac_charge_code,
                                ce_ent_code: selectedEntity?.ent_code,
                                ce_charge_basis: selectedProductEndCharge?.ac_charge_basis,
                                ce_charge_rate: selectedProductEndCharge?.ac_charge_rate,
                                ce_charge_rate_per: selectedProductEndCharge?.ac_charge_rate_per
                              }
                            );

                            if (res.data?.msg === "added") {
                              setEntityCharges((prevData) => [...prevData, res.data?.doc]);
                              setSelectedEntity(null);
                              showToast(t('added'), "success");
                            } else if (res.data === "exists") {
                              showToast(`${selectedEntity?.ent_name} already added`, "error");
                            } else {
                              showToast("Error adding entity!", "error");
                            }
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        color="#0ea5a4"
                        icon={<MdAdd />}
                        width={"35px"}
                        height={"35px"} />
                    </div>
                  </span>
                </div>
                <div className="endorsements-wrapper" style={{ marginBottom: "80px" }}>
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableBody className="tablebody">
                          {entityCharges?.map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className={`${selectedEntityCharge?._id === row._id ? "tablerow current" : "tablerow"}`}
                              onClick={() => setSelectedEntityCharge(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                {index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto" }}>
                                <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                  <span className="sub-title">{row?.ent_name_xx}</span>
                                  <span className="sub-title soft" style={{ fontSize: "10px" }}>{row?.ent_status_xx}</span>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                                <Select
                                  id="ce_charge_basis"
                                  name="ce_charge_basis"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="175px"
                                  height="32px"
                                  dropdownHeight={3 * 42}
                                  value={endChargeBasis.find((option) => option.value === row?.ce_charge_basis) || null}
                                  onChange={(selectedOption) => handleEntityChargeChange(selectedOption?.value, row._id, "ce_charge_basis")}
                                  options={endChargeBasis}
                                  placeholder={`${t('basis')}`}
                                />
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id="ce_charge_rate"
                                    name="ce_charge_rate"
                                    type="text"
                                    placeholder="0.00"
                                    style={{ width: "100%", textAlign: "right" }}
                                    className="form-input-item table"
                                    value={row?.ce_charge_rate}
                                    onChange={(e) => handleEntityChargeChange(e.target.value, row._id, "ce_charge_rate")}
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id="ce_charge_rate_per"
                                    name="ce_charge_rate_per"
                                    type="text"
                                    placeholder="0.00"
                                    style={{ width: "100%", textAlign: "right" }}
                                    className="form-input-item table"
                                    value={row?.ce_charge_rate_per}
                                    onChange={(e) => handleEntityChargeChange(e.target.value, row._id, "ce_charge_rate_per")}
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx) || row?.ac_charge_basis === "Fixed Amount"}
                                  />
                                </div>
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={async () => {
                                      try {
                                        const res = await newRequest.delete(`/uwProductEndCharge/delEntityCharge/${row?._id}`);
                                        if (res.data.msg === "deleted") {
                                          setEntityCharges((prevData) => prevData.filter(val => val._id !== row?._id));
                                          showToast(t('removed'), "success");
                                        } else {
                                          showToast("Error removing charge!", "error");
                                        }
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    color="#E53935"
                                    icon={<MdDelete />}
                                    width={"30px"}
                                    height={"30px"} />
                                </TableCell>}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                </div>


              </div>
              {/* classes  */}
              <div className="sub-class-section">
                <div className="sub-class-toolbar">
                  <div className="input-item-with-label">
                    <label htmlFor="sccode">{t('subClasses').toUpperCase()}</label>
                    <AsyncSelect
                      id="sccode"
                      name="sccode"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="350px"
                      value={selectedSubClass}
                      onChange={(selectedOption) => setSelectedSubClass(selectedOption)}
                      loadOptions={fetchSubClasses}
                      isSearchable={true}
                      placeholder="Select Sub Class"
                      noOptionsMessage={() => "Type Minimum 2 Letter to Search"}
                    />
                    <hr className="separator-v" />
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="right"
                      variant="tint"
                      color="#0ea5a4"
                      tooltip={`${t('add')} ${selectedSubClass?.label}`}
                      endIcon={<MdAdd />}
                      onClick={async () => {
                        try {

                          if (!selectedSubClass) {
                            setNotifyDialogTitle("Note!");
                            setNotifyDialogText(`Please select sub class`);
                            setIsNotifyDialogOpen(true);
                            return;
                          }

                          setIsProcessing(true);
                          // console.log(`selectedSubClass  ${JSON.stringify(selectedSubClass, null, 2)}`);

                          // // insert receipt line
                          const res = await newRequest.post("/uwProductSc/add", {
                            ps_mc_code: selectedSubClass?.sc_mc_code,
                            ps_pr_code: prCode,
                            ps_sc_code: selectedSubClass?.value,
                            ps_view: selectedSubClass?.sc_view
                          },);


                          if (res.data === "exists") {
                            showToast(`Sub class ${selectedSubClass?.label} - ${selectedSubClass?.value} already part of this product`, "error");
                          } else {
                            setSelectedSubClass(null);
                            setProductSc((prevSc) => [...prevSc, res.data]);
                            showToast(`Sub class ${selectedSubClass?.label} - ${selectedSubClass?.value} added`, "success");
                          }
                        } catch (error) {
                          console.log(error);
                        } finally {
                          setIsProcessing(false);
                        }
                      }}
                    >
                      {t('add')}
                    </CustomLoadingButton>
                  </div>
                </div>
                <div className="sub-class-wrapper">
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "200px" }}>
                              <span>{t('class').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                              <span>{t('subClass').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "150px" }}>
                              <span>{t('default').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "150px" }}>
                              <span>{t('enabled').toUpperCase()}</span>
                            </TableCell>
                            {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <span>{t('action').toUpperCase()}</span>
                              </TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {productSc?.map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className={`${selectedProductSc?._id === row._id ? "tablerow current" : "tablerow"}`}
                              onClick={() => {
                                try {
                                  setSelectedProductSc(row);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                {index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "200px" }}>
                                <h1 className="sub-title">{row?.ps_mc_code} - {row?.mc_code_xx}</h1>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto" }}>
                                <h1 className="sub-title">{row?.ps_sc_code} - {row?.sc_name_xx}</h1>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "150px" }}>
                                <ToggleSwitch
                                  id={row._id}
                                  value={row.ps_default}
                                  onChange={(newValue) => handleProductScChange(newValue, row._id, "ps_default")}
                                  label=""
                                  labelPosition="end"
                                  labelWidth="max-content"
                                  border="N"
                                  disabled={false}
                                />
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "150px" }}>
                                <ToggleSwitch
                                  id={row._id}
                                  value={row.ps_enabled}
                                  onChange={(newValue) => handleProductScChange(newValue, row._id, "ps_enabled")}
                                  label=""
                                  labelPosition="end"
                                  labelWidth="max-content"
                                  border="N"
                                  disabled={false}
                                />
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px", }}>
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={() => {
                                      try {
                                        setObjectToAction({
                                          object_id: row._id,
                                          action_text: `Delete ${row?.sc_name_xx}?`,
                                          new_doc_status: "deleteSubClass",
                                        });
                                        setConfirmationActiontext(`Delete ${row?.sc_name_xx}?`);
                                        setConfirmDialogAction("deleteSubClass");
                                        setIsConfirmDialogOpen(true);
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    color="#E53935" icon={<MdDelete />} width={"30px"} height={"30px"} />
                                </TableCell>}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
              {/* conditions */}
              <div className="conditions-section">
                <div className="conditions-toolbar">
                  <div className="conditions-toolbar-left">
                    <div className="search-input-wrapper" style={{ width: "99%" }}>
                      <FiSearch className="search-input-icon" />
                      <input
                        className="search-input"
                        type="text"
                        placeholder={t('search')}
                        value={conditionSearchTerm}
                        onChange={(e) => setConditionSearchTerm(e.target.value)}
                      />
                      {conditionSearchTerm.length > 0 && (
                        <IoClose
                          onClick={() => {
                            try {
                              setSelectedProductCond(null);
                              setConditionSearchTerm("");
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          className="search-input-icon"
                        />
                      )}
                    </div>
                  </div>
                  <div className="conditions-toolbar-right">
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#26A69A"
                      endIcon={<MdAdd />}
                      onClick={() => {
                        try {
                          setObjectToAction({
                            object_id: "",
                            action_text: "",
                            new_doc_status: "newCondition",
                          });
                          setIsNewConditionOpen(true);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      {t('addCondition')}
                    </CustomLoadingButton>
                  </div>
                </div>
                <div className="conditions-wrapper">
                  <div className="conditions-left">
                    <div className="table-content">
                      <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                        <Table sx={{ width: "max-content", border: 'none' }}>
                          <TableHead className="tablehead">
                            <TableRow className="tablerow">
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                #
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                <span>{t('code').toUpperCase()}</span>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "300px" }}>
                                <span>{t('name').toUpperCase()}</span>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody className="tablebody">
                            {slicedConditionsData
                              ?.filter(
                                (row) =>
                                  row?.cond_code?.toLowerCase().includes(conditionSearchTerm?.toLowerCase()) ||
                                  row?.cond_name?.toLowerCase().includes(conditionSearchTerm?.toLowerCase()) ||
                                  row?.cond_ref_no?.toLowerCase().includes(conditionSearchTerm?.toLowerCase()) ||
                                  row?.cond_desc?.toLowerCase().includes(conditionSearchTerm?.toLowerCase())
                              )
                              .map((row, index) => (
                                <TableRow
                                  key={row?._id}
                                  className={`${selectedProductCond?._id === row._id ? "tablerow current" : "tablerow"}`}
                                  onClick={() => setSelectedProductCond(row)}
                                >
                                  <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                    <h1 className="normal-title">{conditionsPage * conditionsRowsPerPage + index + 1}</h1>
                                  </TableCell>
                                  <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                    <h1 className="sub-title">{row?.cond_code}</h1>
                                  </TableCell>
                                  <TableCell className="table-cell left" style={{ maxWidth: "300px" }}>
                                    <h1 className="sub-title">{row?.cond_name}</h1>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                        <TablePagination
                          rowsPerPageOptions={[5]}
                          rowsPerPage={conditionsRowsPerPage}
                          onRowsPerPageChange={handleConditionsChangeRowsPerPage}
                          component="div"
                          count={productConds.length}
                          page={conditionsPage}
                          onPageChange={handleConditionsChangePage}
                        />
                      </TableContainer>
                    </div>
                  </div>
                  <div className="conditions-right">
                    <div className="conditions-form-wrapper">
                      <div className="conditions-form-left">
                        <div className="input-item-with-label">
                          <input
                            id="cond_name"
                            name="cond_name"
                            type="text"
                            value={selectedProductCond?.cond_name}
                            placeholder="Name"
                            style={{ width: "100%" }}
                            className="form-input-item"
                            onChange={(e) => {
                              if (selectedProductCond) {
                                handleProductCondsChange(e.target.value, selectedProductCond._id, "cond_name");
                              }
                            }}
                            disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                          />
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%", height: "45px", alignItems: "center" }}>
                          <ToggleSwitch
                            id={selectedProductCond?.cond_mandatory}
                            value={selectedProductCond?.cond_mandatory}
                            onChange={(newValue) => handleProductCondsChange(newValue, selectedProductCond?._id, "cond_mandatory")}
                            label={t('mandatory').toUpperCase()}
                            labelPosition="end"
                            labelWidth="max-content"
                            border="N"
                          />
                          <ToggleSwitch
                            id={selectedProductCond?.cond_default}
                            value={selectedProductCond?.cond_default}
                            onChange={(newValue) => handleProductCondsChange(newValue, selectedProductCond?._id, "cond_default")}
                            label={t('default').toUpperCase()}
                            labelPosition="end"
                            labelWidth="max-content"
                            border="N"
                          />
                          <ToggleSwitch
                            id={selectedProductCond?.cond_enabled}
                            value={selectedProductCond?.cond_enabled}
                            onChange={(newValue) => handleProductCondsChange(newValue, selectedProductCond?._id, "cond_enabled")}
                            label={t('enabled').toUpperCase()}
                            labelPosition="end"
                            labelWidth="max-content"
                            border="N"
                          />
                        </div>
                      </div>
                      <div className="conditions-form-right">
                        <div style={{ display: "flex", flexDirection: "row", gap: "5px", justifyContent: "flex-end", width: "100%", height: "45px", alignItems: "center" }}>
                          <div className="input-item-with-label">
                            <label
                              htmlFor="cond_order"
                              className="form-dropdown-label"
                              style={{ width: "max-content" }}
                            >
                              {t('order').toUpperCase()}
                            </label>
                            <input
                              id="cond_order"
                              name="cond_order"
                              type="text"
                              value={selectedProductCond?.cond_order}
                              style={{ width: "50px" }}
                              className="form-input-item"
                              onChange={(e) => handleProductCondsChange(e.target.value, selectedProductCond._id, "cond_order")}
                              disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                            />
                          </div>
                          <div className="input-item-with-label">
                            <label
                              htmlFor="cond_ref_no"
                              className="form-dropdown-label"
                              style={{ width: "max-content" }}
                            >
                              {t('refNo').toUpperCase()}
                            </label>
                            <input
                              id="cond_ref_no"
                              name="cond_ref_no"
                              type="text"
                              value={selectedProductCond?.cond_ref_no}
                              placeholder={t('refNo').toUpperCase()}
                              style={{ width: "110px" }}
                              className="form-input-item"
                              onChange={(e) => handleProductCondsChange(e.target.value, selectedProductCond._id, "cond_ref_no")}
                              disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                            />
                          </div>
                        </div>
                        <div className="input-item-with-label">
                          <label htmlFor="cond_type" style={{ width: "max-content" }}>{t('type').toUpperCase()}</label>
                          <Select
                            id="cond_type"
                            name="cond_type"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="225px"
                            value={wordingTypes.find((option) => option.value === selectedProductCond?.cond_type) || null}
                            onChange={(selectedOption) => handleProductCondsChange(selectedOption?.value, selectedProductCond._id, "cond_type")}
                            options={wordingTypes}
                            isSearchable={true}
                            placeholder={t('type').toUpperCase()}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="input-item-with-label">
                      <textarea
                        id="cond_desc"
                        name="cond_desc"
                        type="text"
                        rows={15}
                        value={selectedProductCond?.cond_desc}
                        placeholder="Text"
                        style={{ width: "100%" }}
                        className="form-input-item"
                        onChange={(e) => handleProductCondsChange(e.target.value, selectedProductCond._id, "cond_desc")}
                        disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* deductibles */}
              <div className="deductibles-section">
                <div className="deductibles-toolbar">
                  <div className="deductibles-toolbar-left">
                    <div className="search-input-wrapper" style={{ width: "99%" }}>
                      <FiSearch className="search-input-icon" />
                      <input
                        className="search-input"
                        type="text"
                        placeholder={t('search')}
                        value={excessSearchTerm}
                        onChange={(e) => setExcessSearchTerm(e.target.value)}
                      />
                      {excessSearchTerm.length > 0 && (
                        <MdClose
                          onClick={() => setExcessSearchTerm("")}
                          className="search-input-icon"
                        />
                      )}
                    </div>
                  </div>
                  <div className="deductibles-toolbar-right">
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#26A69A"
                      endIcon={<MdAdd />}
                      onClick={() => {
                        try {
                          setObjectToAction({
                            object_id: "",
                            action_text: "",
                            new_doc_status: "newDeductible",
                          });
                          setIsNewConditionOpen(true);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      {t('addDeductible')}
                    </CustomLoadingButton>
                  </div>
                </div>
                <div className="deductibles-wrapper">
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                              <span>{t('name').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "210px" }}>
                              <span>{t('type').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                              <span>{t('rate').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                              <span>{t('order').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                              <span>{t('mandatory').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                              <span>{t('default').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                              <span>{t('enabled').toUpperCase()}</span>
                            </TableCell>
                            {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <span>{t('action').toUpperCase()}</span>
                              </TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {slicedExcessData
                            ?.filter(
                              (row) =>
                                row?.ed_text?.toLowerCase().includes(excessSearchTerm.toLowerCase())
                            )
                            .map((row, index) => (
                              <TableRow
                                key={row?._id}
                                className={`${selectedProductExcess?._id === row._id ? "tablerow current" : "tablerow"}`}
                                onClick={async () => setSelectedProductExcess(row)}
                              >
                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                  <h1 className="normal-title">{excessPage * excessRowsPerPage + index + 1}</h1>
                                </TableCell>
                                <TableCell className="table-cell left" style={{ width: "auto", gap: "5px" }}>
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <textarea
                                      id="ed_text"
                                      name="ed_text"
                                      type="text"
                                      value={row?.ed_text}
                                      rows={4}
                                      placeholder={t('text').toUpperCase()}
                                      style={{ width: "100%" }}
                                      className="form-input-item table"
                                      onChange={(e) => handleProductExcessChange(e.target.value, row._id, "ed_text")}
                                      disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className="table-cell left" style={{ maxWidth: "210px" }}>
                                  <Select
                                    id="ed_type"
                                    name="ed_type"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="200px"
                                    value={excessTypes.find((option) => option.value === row?.ed_type) || null}
                                    onChange={(selectedOption) => {
                                      try {
                                        handleProductExcessChange(selectedOption?.value, row._id, "ed_type")
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    options={excessTypes}
                                    isSearchable={true}
                                    placeholder={t('type').toUpperCase()}
                                  />
                                </TableCell>
                                <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id="ed_value"
                                      name="ed_value"
                                      type="text"
                                      value={row?.ed_value}
                                      placeholder="0.00"
                                      style={{ width: "100%", textAlign: "right" }}
                                      className="form-input-item table"
                                      onChange={(e) => handleProductExcessChange(e.target.value, row._id, "ed_value")}
                                      disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id="ed_order"
                                      name="ed_order"
                                      type="text"
                                      value={row?.ed_order}
                                      placeholder="Name"
                                      style={{ width: "100%", textAlign: "right" }}
                                      className="form-input-item table"
                                      onChange={(e) => handleProductExcessChange(e.target.value, row._id, "ed_order")}
                                      disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                                  <ToggleSwitch
                                    value={row.ed_mandatory}
                                    onChange={(newValue) => handleProductExcessChange(newValue, row._id, "ed_mandatory")}
                                    label=""
                                    labelPosition="end"
                                    labelWidth="max-content"
                                    border="N"
                                  />
                                </TableCell>
                                <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                                  <ToggleSwitch
                                    value={row?.ed_default}
                                    onChange={(newValue) => handleProductExcessChange(newValue, row._id, "ed_default")}
                                    label=""
                                    labelPosition="end"
                                    labelWidth="max-content"
                                    border="N"
                                  />
                                </TableCell>
                                <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                  <ToggleSwitch
                                    value={row?.ed_enabled}
                                    onChange={(newValue) => handleProductExcessChange(newValue, row._id, "ed_enabled")}
                                    label=""
                                    labelPosition="end"
                                    labelWidth="max-content"
                                    border="N"
                                  />
                                </TableCell>
                                {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                  <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                    <CircularButton
                                      currentTheme={currentTheme}
                                      onClick={() => {
                                        try {
                                          setObjectToAction({
                                            object_id: row._id,
                                            action_text: `Delete ${row?.ed_text}?`,
                                            new_doc_status: "deleteExcess",
                                          });
                                          setConfirmationActiontext(`Delete ${row?.ed_text}?`);
                                          setConfirmDialogAction("deleteExcess");
                                          setIsConfirmDialogOpen(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                      color="#E53935" icon={<MdDelete />} width={"30px"} height={"30px"} />
                                  </TableCell>}
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[4]}
                        rowsPerPage={excessRowsPerPage}
                        onRowsPerPageChange={handleExcessChangeRowsPerPage}
                        component="div"
                        count={productExcess.length}
                        page={excessPage}
                        onPageChange={handleExcessChangePage}
                      />
                    </TableContainer>
                  </div>
                </div>
              </div>
              <div className="templates-section">
                <div className="templates-toolbar">
                  <div className="input-item-with-label">
                    <label htmlFor="templateDays"
                      className="form-input-label"
                      style={{ width: "100px" }}>
                      {t('days').toUpperCase()}
                    </label>
                    <input
                      name="templateDays"
                      type="number"
                      placeholder="0"
                      className="form-input-item"
                      style={{ width: "60px", marginRight: "10px", textAlign: "right" }}
                      value={templateDays}
                      onChange={(e) => setTemplateDays(e.target.value)}
                    />
                    <label htmlFor="selectedTemplate">{t('template').toUpperCase()}</label>
                    <Select
                      id="selectedTemplate"
                      name="selectedTemplate"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="400px"
                      value={selectedTemplate}
                      onChange={(selectedOption) => setSelectedTemplate(selectedOption)}
                      options={templates}
                      isSearchable={true}
                      placeholder={t('template').toUpperCase()}
                    />
                    <hr className="separator-v" />
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="right"
                      variant="tint"
                      color="#0ea5a4"
                      tooltip={`${t('add')} ${selectedTemplate?.label}`}
                      endIcon={<MdAdd />}
                      onClick={async () => {
                        try {

                          if (!templateDays || templateDays <= 0) {
                            setNotifyDialogTitle("Note!");
                            setNotifyDialogText(`Please enter days greater than 0`);
                            setIsNotifyDialogOpen(true);
                            return;
                          }

                          if (!selectedTemplate) {
                            setNotifyDialogTitle("Note!");
                            setNotifyDialogText(`Please select template`);
                            setIsNotifyDialogOpen(true);
                            return;
                          }

                          setIsProcessing(true);

                          const res = await newRequest.post("/uwProduct/addRenewalDays", {
                            product_docid: productData?._id,
                            renewal_days: templateDays,
                            renewal_template_docid: selectedTemplate?.value
                          },);

                          if (res.data === "error") {
                            showToast(res.data?.doc, "error");
                          } else {
                            setTemplateDays(0);
                            setTemplateDays(null);
                            setPrRenewalDays((prevSc) => [...prevSc, res.data?.doc]);
                            showToast(`Added`, "success");
                          }
                        } catch (error) {
                          console.log(error);
                        } finally {
                          setIsProcessing(false);
                        }
                      }}
                    >
                      {t('add')}
                    </CustomLoadingButton>
                  </div>
                </div>
                <div className="templates-wrapper">
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                              <span>{t('days').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                              <span>{t('template').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "200px" }}>
                              <span>{t('action').toUpperCase()}</span>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {prRenewalDays?.map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className={`${selectedRenewalDay?._id === row._id ? "tablerow current" : "tablerow"}`}
                              onClick={() => setSelectedRenewalDay(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                {index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                <h1 className="sub-title">{row?.renewal_days}</h1>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto" }}>
                                <h1 className="sub-title">{row?.tpt_name}</h1>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ display: "flex", flexDirection: "row", gap: "10px", maxWidth: "200px", }}>
                                <CustomLoadingButton
                                  currentTheme={currentTheme}
                                  borderRadiusType="both"
                                  height={"32px"}
                                  iconPosition="end"
                                  endIcon={<MdOutlinePreview />}
                                  onClick={() => {
                                    try {
                                      setPreviewEmailContent(replaceTags(row?.tpt_email_content, currentUser));
                                      setPreviewSmsContent(replaceTags(row?.tpt_sms_content, currentUser));
                                      setIsPreviewOpen(true);
                                    } catch (error) {
                                      console.log(error)
                                    }
                                  }}
                                >
                                  {t('preview')}
                                </CustomLoadingButton>
                                {["admin", "superadmin"].includes(currentUser?.user_type_xx) &&
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={async () => {
                                      try {
                                        const res = await newRequest.post("/uwProduct/deleteRenewalDays", {
                                          product_docid: productData?._id,
                                          renewal_days_docid: row?._id
                                        });
                                        if (res.data === "removed") {
                                          setPrRenewalDays((prevSc) => prevSc.filter(param => param._id !== row?._id));
                                          setIsConfirmDialogOpen(false);
                                          showToast("Removed!", "success");
                                        } else {
                                          showToast("Error removing sub class!", "error");
                                        }
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    color="#E53935"
                                    icon={<MdDelete />}
                                    width={"30px"}
                                    height={"30px"} />
                                }
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
              <div className="limits-section">
                {/* limit and benefits */}
                <ExpandableComponent
                  title={t('limits').toUpperCase()}
                  subtitle={
                    <div className="limits-toolbar">
                      <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                        <input
                          ref={limitTextRef}
                          id="limit_text"
                          name="limit_text"
                          type="text"
                          value={addLimitText}
                          placeholder={t('limit').toUpperCase()}
                          style={{ width: "250px" }}
                          className="form-input-item table"
                          onChange={(e) => setAddLimitText(e.target.value)}
                        />
                        <input
                          ref={limitAmountRef}
                          id="limit_amount"
                          name="limit_amount"
                          type="text"
                          value={addLimitAmount}
                          placeholder={t('amount').toUpperCase()}
                          style={{ width: "150px", textAlign: "end" }}
                          className="form-input-item table"
                          onChange={(e) => setAddLimitAmount(e.target.value)}
                        />
                        <CircularButton
                          currentTheme={currentTheme}
                          onClick={async (e) => {
                            try {

                              if (!addLimitText) {
                                setNotifyDialogTitle("Note!");
                                setNotifyDialogText(`Please enter limit text`);
                                setIsNotifyDialogOpen(true);
                                return;
                              }

                              const res = await newRequest.post(
                                "/uwProduct/addLimit",
                                {
                                  product_docid: productDocId,
                                  limit_text: addLimitText,
                                  limit_amount: addLimitAmount || "",
                                }
                              );

                              if (res.data?.msg === "added") {
                                setPrLimits((prevParams) => [...prevParams, res.data?.doc]);
                                setAddLimitText("");
                                setAddLimitAmount("");
                                showToast(t('added'), "success");
                                if (limitTextRef.current) {
                                  limitTextRef.current?.focus();
                                }
                              } else {
                                showToast("Error adding limit!", "error");
                              }
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          color="#0ea5a4"
                          icon={<MdAdd />}
                          width={"35px"}
                          height={"35px"} />
                      </div>
                    </div>
                  }
                  defaultExpanded={true}
                >
                  <div className="deductibles-wrapper">
                    {prLimitYn === "N" && prLimits?.length > 0 && <span className="sub-title" style={{ color: "red" }}>{t('limitsWontShow')}</span>}
                    <div className="table-content">
                      <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                        <Table sx={{ width: "max-content", border: 'none' }}>
                          <TableHead className="tablehead">
                            <TableRow className="tablerow">
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                #
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto" }}>
                                {/* <span>{t('text').toUpperCase()}</span> */}
                                <div className="search-input-wrapper table" style={{ width: "90%" }}>
                                  <FiSearch className="search-input-icon table" />
                                  <input
                                    className="search-input table"
                                    type="text"
                                    placeholder={`${t('search')} ${t('limit')}`}
                                    value={limitSearchTerm}
                                    onChange={(e) => setLimitSearchTerm(e.target.value)}
                                  />
                                  {limitSearchTerm.length > 0 && (
                                    <MdClose
                                      onClick={() => setLimitSearchTerm("")}
                                      className="search-input-icon table"
                                    />
                                  )}
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                <span>{t('limit').toUpperCase()}</span>
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                  <span>{t('action').toUpperCase()}</span>
                                </TableCell>}
                            </TableRow>
                          </TableHead>
                          <TableBody className="tablebody">
                            {prLimits
                              ?.filter(
                                (row) =>
                                  row?.limit_text?.toLowerCase().includes(limitSearchTerm.toLowerCase())
                              ).map((row, index) => (
                                <TableRow
                                  key={row?._id}
                                  className={`${selectedLimit?._id === row._id ? "tablerow current" : "tablerow"}`}
                                  onClick={async () => setSelectedLimit(row)}
                                >
                                  <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                    <h1 className="normal-title">{index + 1}</h1>
                                  </TableCell>
                                  <TableCell className="table-cell left" style={{ width: "auto", gap: "5px" }}>
                                    <div className="input-item-with-label" style={{ width: "100%" }}>
                                      <input
                                        id="limit_text"
                                        name="limit_text"
                                        type="text"
                                        value={row?.limit_text}
                                        placeholder={t('limit').toUpperCase()}
                                        style={{ width: "100%" }}
                                        className="form-input-item table"
                                        onChange={(e) => handleProductLimitChange(e.target.value, row._id, "limit_text")}
                                        disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                      />
                                    </div>
                                  </TableCell>
                                  <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                    <div className="input-item-with-label" style={{ width: "100%" }}>
                                      <input
                                        id="limit_amount"
                                        name="limit_amount"
                                        type="text"
                                        value={row?.limit_amount}
                                        placeholder={t('amount').toUpperCase()}
                                        style={{ width: "100%", textAlign: "right" }}
                                        className="form-input-item table"
                                        onChange={(e) => handleProductLimitChange(e.target.value, row._id, "limit_amount")}
                                        disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                      />
                                    </div>
                                  </TableCell>
                                  {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                    <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                      <CircularButton
                                        currentTheme={currentTheme}
                                        onClick={async () => {
                                          try {
                                            const res = await newRequest.post("/uwProduct/deleteLimit", {
                                              product_docid: productDocId,
                                              limit_docid: row?._id
                                            });
                                            if (res.data === "removed") {
                                              setPrLimits((prevData) =>
                                                prevData.filter(param => param._id !== row?._id)
                                              );
                                              showToast(t('removed'), "success");
                                            } else {
                                              showToast("Error removing limit!", "error");
                                            }
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                        color="#E53935" icon={<MdDelete />} width={"30px"} height={"30px"} />
                                    </TableCell>}
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </ExpandableComponent>
                {/* <hr className="separator-h" /> */}
                <ExpandableComponent
                  title={t('benefits').toUpperCase()}
                  subtitle={
                    <div className="limits-toolbar">
                      <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                        <input
                          ref={benefitTextRef}
                          id="benefit_text"
                          name="benefit_text"
                          type="text"
                          value={addBenefitText}
                          placeholder={t('benefit').toUpperCase()}
                          style={{ width: "250px" }}
                          className="form-input-item table"
                          onChange={(e) => setAddBenefitText(e.target.value)}
                        />
                        <input
                          ref={benefitAmountRef}
                          id="benefit_amount"
                          name="benefit_amount"
                          type="text"
                          value={addBenefitAmount}
                          placeholder={t('amount').toUpperCase()}
                          style={{ width: "150px", textAlign: "end" }}
                          className="form-input-item table"
                          onChange={(e) => setAddBenefitAmount(e.target.value)}
                        />
                        <CircularButton
                          currentTheme={currentTheme}
                          onClick={async (e) => {
                            try {

                              if (!addBenefitText) {
                                setNotifyDialogTitle("Note!");
                                setNotifyDialogText(`Please enter benefit text`);
                                setIsNotifyDialogOpen(true);
                                return;
                              }

                              const res = await newRequest.post(
                                "/uwProduct/addBenefit",
                                {
                                  product_docid: productDocId,
                                  benefit_text: addBenefitText,
                                  benefit_amount: addBenefitAmount || "",
                                }
                              );

                              if (res.data?.msg === "added") {
                                setPrBenefits((prevParams) => [...prevParams, res.data?.doc]);
                                setAddBenefitText("");
                                setAddBenefitAmount("");
                                showToast(t('added'), "success");
                                if (benefitTextRef.current) {
                                  benefitTextRef.current?.focus();
                                }
                              } else {
                                showToast("Error adding benefit!", "error");
                              }
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          color="#0ea5a4"
                          icon={<MdAdd />}
                          width={"35px"}
                          height={"35px"} />
                      </div>
                    </div>
                  }
                  defaultExpanded={true}
                >
                  <div className="deductibles-wrapper">
                    {prBenefitYn === "N" && prBenefits?.length > 0 && <span className="sub-title" style={{ color: "red" }}>{t('benefitsWontShow')}</span>}
                    <div className="table-content">
                      <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                        <Table sx={{ width: "max-content", border: 'none' }}>
                          <TableHead className="tablehead">
                            <TableRow className="tablerow">
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                #
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto" }}>
                                {/* <span>{t('text').toUpperCase()}</span> */}
                                <div className="search-input-wrapper table" style={{ width: "90%" }}>
                                  <FiSearch className="search-input-icon table" />
                                  <input
                                    className="search-input table"
                                    type="text"
                                    placeholder={t('search')}
                                    value={benefitSearchTerm}
                                    onChange={(e) => setBenefitSearchTerm(e.target.value)}
                                  />
                                  {benefitSearchTerm.length > 0 && (
                                    <MdClose
                                      onClick={() => setBenefitSearchTerm("")}
                                      className="search-input-icon table"
                                    />
                                  )}
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                <span>{t('benefit').toUpperCase()}</span>
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                  <span>{t('action').toUpperCase()}</span>
                                </TableCell>}
                            </TableRow>
                          </TableHead>
                          <TableBody className="tablebody">
                            {prBenefits
                              ?.filter(
                                (row) =>
                                  row?.benefit_text?.toLowerCase().includes(benefitSearchTerm?.toLowerCase())
                              )
                              .map((row, index) => (
                                <TableRow
                                  key={row?._id}
                                  className={`${selectedBenefit?._id === row._id ? "tablerow current" : "tablerow"}`}
                                  onClick={async () => setSelectedBenefit(row)}
                                >
                                  <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                    <h1 className="normal-title">{index + 1}</h1>
                                  </TableCell>
                                  <TableCell className="table-cell left" style={{ width: "auto", gap: "5px" }}>
                                    <div className="input-item-with-label" style={{ width: "100%" }}>
                                      <input
                                        id="benefit_text"
                                        name="benefit_text"
                                        type="text"
                                        value={row?.benefit_text}
                                        placeholder={t('text').toUpperCase()}
                                        style={{ width: "100%" }}
                                        className="form-input-item table"
                                        onChange={(e) => handleProductBenefitChange(e.target.value, row._id, "benefit_text")}
                                        disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                      />
                                    </div>
                                  </TableCell>
                                  <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                    <div className="input-item-with-label" style={{ width: "100%" }}>
                                      <input
                                        id="benefit_amount"
                                        name="benefit_amount"
                                        type="text"
                                        value={row?.benefit_amount}
                                        placeholder={t('amount').toUpperCase()}
                                        style={{ width: "100%", textAlign: "right" }}
                                        className="form-input-item table"
                                        onChange={(e) => handleProductBenefitChange(e.target.value, row._id, "benefit_amount")}
                                        disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                      />
                                    </div>
                                  </TableCell>
                                  {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                    <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                      <CircularButton
                                        currentTheme={currentTheme}
                                        onClick={async () => {
                                          try {
                                            const res = await newRequest.post("/uwProduct/deleteBenefit", {
                                              product_docid: productDocId,
                                              benefit_docid: row?._id
                                            });
                                            if (res.data === "removed") {
                                              setPrBenefits((prevData) =>
                                                prevData.filter(param => param._id !== row?._id)
                                              );
                                              showToast(t('removed'), "success");
                                            } else {
                                              showToast("Error removing benefit!", "error");
                                            }
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                        color="#E53935" icon={<MdDelete />} width={"30px"} height={"30px"} />
                                    </TableCell>}
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </ExpandableComponent>
              </div>
              {/* ON SCREEN REPORTS */}
              <div>
                <div className="table-content">
                  <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                    <Table sx={{ width: "max-content", border: 'none' }}>
                      <TableHead className="tablehead">
                        <TableRow className="tablerow">
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            #
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                            <div style={{ display: "flex", width: "100%", flexDirection: "row", gap: "10px", alignItems: "center", justifyContent: "center" }}>
                              <div className="search-input-wrapper table" style={{ width: "90%" }}>
                                <FiSearch className="search-input-icon table" />
                                <input
                                  className="search-input table"
                                  type="text"
                                  placeholder={t('search')}
                                  value={reportSearchTerm}
                                  onChange={(e) => setReportSearchTerm(e.target.value)}
                                />
                                {reportSearchTerm?.length > 0 && (
                                  <MdClose onClick={() => setReportSearchTerm("")}
                                    className="search-input-icon table"
                                  />
                                )}
                              </div>
                              <CircularButton
                                currentTheme={currentTheme}
                                onClick={async () => {
                                  try {
                                    setCurrentAction("addReport");
                                    setReportOrder(0);
                                    setReportTitle(null);
                                    setReportIcon(null);
                                    setReportDesc(null);
                                    setReportFileName(null);
                                    setReportFilePath(null);
                                    setReportEndpoint(null);
                                    setReportEnabled("Y");
                                    setSelectedIcon({
                                      value: "Home",
                                      label: <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        {<Home />} {"Home"}
                                      </div>
                                    });
                                    setReportFormat({
                                      value: "pdf",
                                      label: "pdf"
                                    });
                                    setReportFormatChange("Y");
                                    setReportBackground("N");
                                    setIsReportDialogOpen(true);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                color="#0ea5a4"
                                icon={<MdAdd />}
                                width={"35px"}
                                height={"35px"} />
                            </div>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "300px" }}>
                            <span>{t('file').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                            <span>{t('endpoint').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                            <span>{t('tag').toUpperCase()}</span>
                          </TableCell>
                          {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                              <span>{t('action').toUpperCase()}</span>
                            </TableCell>}
                        </TableRow>
                      </TableHead>
                      <TableBody className="tablebody">
                        {reportTemplates
                          ?.filter(
                            (row) =>
                              row?.report_title?.toLowerCase().includes(reportSearchTerm?.toLowerCase()) ||
                              row?.report_file_name?.toLowerCase().includes(reportSearchTerm?.toLowerCase())
                          )
                          .map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className={`${selectedReportTemplate?._id === row?._id ? "tablerow current" : "tablerow"}`}
                              onClick={async () => setSelectedReportTemplate(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id="report_order"
                                    name="report_order"
                                    type="number"
                                    value={row?.report_order}
                                    style={{ width: "100%" }}
                                    className="form-input-item table"
                                    onChange={(e) => handleReportTemplateChange(e.target.value, row._id, "report_order")}
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto", gap: "5px" }}>
                                <div className="input-item-with-label" style={{ width: "100%", gap: "10px" }}>
                                  <input
                                    id="report_title"
                                    name="report_title"
                                    type="text"
                                    value={row?.report_title}
                                    placeholder={t('text').toUpperCase()}
                                    style={{ width: "75%" }}
                                    className="form-input-item table"
                                    onChange={(e) => handleReportTemplateChange(e.target.value, row._id, "report_title")}
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                  />
                                  <span className="sub-title">{row?.report_doc_type}</span>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "300px" }}>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id="report_file_name"
                                    name="report_file_name"
                                    type="text"
                                    value={row?.report_file_name}
                                    placeholder={t('text').toUpperCase()}
                                    style={{ width: "100%" }}
                                    className="form-input-item table"
                                    onChange={(e) => handleReportTemplateChange(e.target.value, row._id, "report_file_name")}
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id="report_endpoint"
                                    name="report_endpoint"
                                    type="text"
                                    value={row?.report_endpoint}
                                    placeholder={t('text').toUpperCase()}
                                    style={{ width: "100%" }}
                                    className="form-input-item table"
                                    onChange={(e) => handleReportTemplateChange(e.target.value, row._id, "report_endpoint")}
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                <span className="sub-title">{row?.report_tag}</span>
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                  <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                                    <CircularButton
                                      currentTheme={currentTheme}
                                      onClick={(e) => {
                                        try {
                                          e.stopPropagation();
                                          const IconComponent = qilloIconMap[row?.report_icon] || GoHomeFill;
                                          setSelectedReportTemplate(row);
                                          setCurrentAction("editReport");
                                          setReportOrder(row?.report_order);
                                          setReportTitle(row?.report_title);
                                          setReportIcon(row?.report_icon);
                                          setReportDesc(row?.report_desc);
                                          setReportFileName(row?.report_file_name);
                                          setReportEndpoint(row?.report_endpoint);
                                          setReportTag({
                                            value: row?.report_tag,
                                            label: row?.report_tag,
                                          });
                                          setSelectedDocumentType({
                                            value: row?.report_doc_type,
                                            label: row?.report_doc_type,
                                          });
                                          setReportFilePath(row?.report_file_path);
                                          setReportEnabled(row?.report_enabled);
                                          setSelectedIcon({
                                            value: row?.report_icon,
                                            label:
                                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <IconComponent className="icon" /> {row?.report_icon}
                                              </div>
                                          });
                                          setReportFormat({
                                            value: row?.report_format,
                                            label: row?.report_format
                                          });
                                          setReportFormatChange(row?.report_format_change);
                                          setReportBackground(row?.report_background);
                                          setIsReportDialogOpen(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }} icon={<MdEdit color="green" />} width={"30px"} height={"30px"} />
                                    <CircularButton
                                      currentTheme={currentTheme}
                                      onClick={(e) => {
                                        try {
                                          e.stopPropagation();
                                          setSelectedReportTemplate(row);
                                          setConfirmationActiontext(`Do you want to delete ${row?.report_title}?`);
                                          setObjectToAction({ object_id: row._id, action_text: `Do you want to delete ${row?.report_title}?`, });
                                          setConfirmDialogAction("deleteReport");
                                          setIsConfirmDialogOpen(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }} color="#E53935" icon={<MdDelete />} width={"30px"} height={"30px"} />
                                  </div>
                                </TableCell>}
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                <hr className="separator-h" />
                <span className="sub-title">{t('riskNotePrintSections')}</span>
                <div className="risk-note-sections">
                  {prRisknoteSections.map((section) => (
                    <div key={section?._id}>
                      {/* <span>{section?.section_title}</span> */}
                      <ToggleSwitch
                        key={section?._id}
                        id={section?._id}
                        value={section?.section_show}
                        onChange={(newValue) =>
                          handleToggleChange(section?._id, newValue)
                        }
                        label={section?.section_title}
                        labelPosition="end"
                        labelWidth="250px"
                        disabled={false}
                        border="Y"
                        style={{
                          width: "300px",
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
              {/* END OF ON SCREEN REPORTS */}
              <div>
                <div className="endorsements-wrapper">
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto", gap: "5px" }}>
                              <span>{t('name').toUpperCase()}</span>
                              <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                  setIsNewSmiDialogOpen(true);
                                  if (newSmiNameRef.current) {
                                    newSmiNameRef.current?.focus();
                                  }
                                }}
                                color="#0ea5a4"
                                icon={<MdAdd />}
                                width={"30px"}
                                height={"30px"} />
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                              <span>{t('rate').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "250px" }}>
                              <span>{t('fclSi').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                              <span>{t('addToSi').toUpperCase()}</span>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                              <span>{t('enabled').toUpperCase()}</span>
                            </TableCell>
                            {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <span>{t('action').toUpperCase()}</span>
                              </TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {expressSmis?.map((row) => (
                            <TableRow
                              key={row?._id}
                              className={`${seletedExpressSmi?._id === row._id ? "tablerow current" : "tablerow"}`}
                              onClick={async () => setSeletedExpressSmi(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id={`exp_order_${row?._id}`}
                                    name={`exp_order_${row?._id}`}
                                    type="number"
                                    value={row?.exp_order}
                                    placeholder="0"
                                    style={{ width: "100%", textAlign: "right" }}
                                    className="form-input-item table"
                                    onChange={(e) => handleExpressSmis(e.target.value, row._id, "exp_order")}
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto", gap: "5px" }}>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id={`exp_smi_name_${row?._id}`}
                                    name={`exp_smi_name_${row?._id}`}
                                    type="text"
                                    value={row?.exp_smi_name}
                                    placeholder={t('name')}
                                    style={{ width: "100%" }}
                                    className="form-input-item table"
                                    onChange={(e) => handleExpressSmis(e.target.value, row._id, "exp_smi_name")}
                                  />
                                </div>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <Select
                                    id={`exp_cc_code_${row?._id}`}
                                    name={`exp_cc_code_${row?._id}`}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="100%"
                                    height="32px"
                                    dropdownHeight={3 * 42}
                                    value={expressCovers.find((option) =>
                                      option.cc_mc_code === row?.exp_mc_code &&
                                      option.cc_sc_code === row?.exp_sc_code &&
                                      option.cc_code === row?.exp_cc_code) || null}
                                    onChange={(selectedOption) => {
                                      try {
                                        handleExpressSmis(selectedOption?.cc_mc_code, row._id, "cc_mc_code");
                                        handleExpressSmis(selectedOption?.cc_sc_code, row._id, "cc_sc_code");
                                        handleExpressSmis(selectedOption?.cc_code, row.cc_code, "exp_cc_code");
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    options={expressCovers}
                                    isSearchable={true}
                                    placeholder={`${t('cover')}`}
                                  />
                                </div>
                                {/* New Multi-select for exp_propagate_si */}
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <Select
                                    id={`exp_propagate_si_${row._id}`}
                                    name={`exp_propagate_si_${row._id}`}
                                    isMulti
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    width="100%"
                                    value={
                                      row?.exp_propagate_si?.map(name => ({
                                        value: name,
                                        label: name,
                                      })) || []
                                    }
                                    onChange={(selectedOptions) => {
                                      const selectedNames = selectedOptions.map(opt => opt.value);
                                      handleExpressSmis(selectedNames, row._id, "exp_propagate_si");
                                    }}
                                    options={expressSmis
                                      .filter(smi => smi._id !== row._id)
                                      .map(smi => ({
                                        value: smi.exp_smi_name,
                                        label: smi.exp_smi_name,
                                      }))
                                    }
                                    placeholder="Propagate SI to..."
                                    isSearchable
                                    closeMenuOnSelect={false}
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "100px", gap: "3px" }}>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id={`exp_rate_${row?._id}`}
                                    name={`exp_rate_${row?._id}`}
                                    type="text"
                                    value={row?.exp_rate}
                                    onChange={(e) => handleExpressSmis(e.target.value, row?._id, 'exp_rate')}
                                    onBlur={() => handleExpressSmisBlur(row?._id, "exp_rate")}
                                    style={{ width: "100%", textAlign: "right" }}
                                    className="form-input-item table"
                                  />
                                </div>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id="exp_rate_per"
                                    name="exp_rate_per"
                                    type="text"
                                    value={row?.exp_rate_per}
                                    onChange={(e) => handleExpressSmis(e.target.value, row?._id, 'exp_rate_per')}
                                    onBlur={() => handleExpressSmisBlur(row?._id, "exp_rate_per")}
                                    style={{ width: "100%", textAlign: "right" }}
                                    className="form-input-item table"
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "250px", gap: "3px" }}>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id={`exp_fcl_${row?._id}`}
                                    name={`exp_fcl_${row?._id}`}
                                    type="text"
                                    value={row?.exp_fcl_value}
                                    onChange={(e) => handleExpressSmis(e.target.value, row?._id, 'exp_fcl_value')}
                                    onBlur={() => handleExpressSmisBlur(row?._id, "exp_fcl_value")}
                                    style={{ width: "100%", textAlign: "right" }}
                                    className="form-input-item table"
                                  />
                                </div>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id={`exp_default_si_${row?._id}`}
                                    name={`exp_default_si_${row?._id}`}
                                    type="text"
                                    value={row?.exp_default_si}
                                    onChange={(e) => handleExpressSmis(e.target.value, row?._id, 'exp_default_si')}
                                    onBlur={() => handleExpressSmisBlur(row?._id, "exp_default_si")}
                                    style={{ width: "100%", textAlign: "right" }}
                                    className="form-input-item table"
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                <ToggleSwitch
                                  id={`exp_add_si_${row?._id}`}
                                  name={`exp_add_si_${row?._id}`}
                                  value={row?.exp_add_to_si}
                                  onChange={(newValue) => handleExpressSmis(newValue, row._id, "exp_add_to_si")}
                                  label=""
                                  labelPosition="end"
                                  labelWidth="max-content"
                                  border="N"
                                />
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                <ToggleSwitch
                                  id={`exp_enabled_${row?._id}`}
                                  name={`exp_enabled_${row?._id}`}
                                  value={row?.exp_enabled}
                                  onChange={(newValue) => handleExpressSmis(newValue, row._id, "exp_enabled")}
                                  label=""
                                  labelPosition="end"
                                  labelWidth="max-content"
                                  border="N"
                                />
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={async () => {
                                      try {
                                        const res = await newRequest.delete(`/uwProduct/deleteExpressSmi/${row?._id}`);
                                        if (res.data === "removed") {
                                          setExpressSmis((prevSc) =>
                                            prevSc
                                              .filter(param => param._id !== row?._id)
                                              .sort((a, b) => a.exp_order - b.exp_order)
                                          );
                                          showToast(t('removed'), "success");
                                        } else {
                                          showToast("Error removing sub class!", "error");
                                        }
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    color="#E53935"
                                    icon={<MdDelete />}
                                    width={"30px"}
                                    height={"30px"} />
                                </TableCell>}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </TabNavigation>
          </div>
        )}
        {isProductTermOpen && (
          <motion.div
            className="overlay-dialog"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
          >
            <div className="overlay-wrapper">
              <div className="overlay-navbar">
                <h1 className="main-title">{t('term').toUpperCase()}</h1>
                <CircularButton
                  currentTheme={currentTheme}
                  onClick={() => {
                    try {
                      setTermAction(null);
                      setIsProductTermOpen(false);
                    } catch (error) {
                      console.log(error)
                    }
                  }} icon={<MdClose />} width={"35px"} height={"35px"} />
              </div>
              <div className="overlay-content-row">
                <div className="overlay-content-right">
                  <div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "5px", }}>
                    <div className="input-item-with-label" >
                      <label htmlFor="term_code" style={{ width: "100px" }}>
                        {t('code').toUpperCase()}
                      </label>
                      <input
                        name="term_code"
                        type="text"
                        placeholder={t('code').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "130px" }}
                        value={termCode}
                        disabled={termAction === "edit"}
                        onChange={(e) => setTermCode(e.target.value)}
                      />
                    </div>
                    <div className="input-item-with-label" style={{ alignSelf: "flex-end" }} >
                      <label htmlFor="term_years" style={{ width: "max-content" }}>
                        {t('years').toUpperCase()}
                      </label>
                      <input
                        name="term_years"
                        type="number"
                        placeholder={t('years').toUpperCase()}
                        className="form-input-item"
                        style={{ width: "80px", textAlign: "right" }}
                        value={termYears}
                        onChange={(e) => setTermYears(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="input-item-with-label">
                    <label htmlFor="term_name" style={{ width: "100px" }}>
                      {t('name').toUpperCase()}
                    </label>
                    <input
                      name="term_name"
                      type="text"
                      placeholder={t('name').toUpperCase()}
                      className="form-input-item"
                      style={{ width: "300px" }}
                      value={termName}
                      onChange={(e) => setTermName(e.target.value)}
                    />
                  </div>
                  <div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", gap: "5px", justifyContent: "flex-end" }}>
                    <label htmlFor="term_min_age" style={{ width: "max-content" }}>
                      ENTRY AGE - MIN
                    </label>
                    <input
                      name="term_min_age"
                      type="number"
                      placeholder="MIN"
                      className="form-input-item"
                      style={{ width: "80px", textAlign: "right" }}
                      value={termMinAge}
                      onChange={(e) => setTermMinAge(e.target.value)}
                    />
                    <label htmlFor="term_max_age" style={{ width: "max-content" }}>
                      {t('max').toUpperCase()}
                    </label>
                    <input
                      name="term_max_age"
                      type="number"
                      placeholder={t('max').toUpperCase()}
                      className="form-input-item"
                      style={{ width: "80px", textAlign: "right" }}
                      value={termMaxAge}
                      onChange={(e) => setTermMaxAge(e.target.value)}
                    />
                  </div>
                  <div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", gap: "5px", justifyContent: "flex-end" }}>
                    <label htmlFor="term_lapse_grace" style={{ width: "max-content" }}>
                      {t('lapseDays').toUpperCase()}
                    </label>
                    <input
                      name="term_lapse_grace"
                      type="number"
                      placeholder={t('lapseDays').toUpperCase()}
                      className="form-input-item"
                      style={{ width: "80px", textAlign: "right" }}
                      value={termLapseGrace}
                      onChange={(e) => setTermLapseGrace(e.target.value)}
                    />
                  </div>
                  <hr className="separator-h" />
                  <span>{t('cashValue').toUpperCase()}</span>
                  <div className="input-item-with-label" style={{ justifyContent: "flex-end" }} >
                    <ToggleSwitch
                      id="term_cash_value"
                      value={termCashValue}
                      onChange={setTermCashValue}
                      label={"APPLICABLE"}
                      labelWidth="max-content"
                      border="N"
                      style={{
                        width: "max-content",
                      }}
                    />
                  </div>
                  <div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", gap: "5px", justifyContent: "flex-end" }}>
                    <label htmlFor="term_cash_value_start" style={{ width: "max-content" }}>
                      YEAR WHEN IT STARTS ACCUMULATING
                    </label>
                    <input
                      name="term_cash_value_start"
                      type="number"
                      placeholder="START YR"
                      className="form-input-item"
                      style={{ width: "80px", textAlign: "right" }}
                      value={termCashValueStart}
                      onChange={(e) => setTermCashValueStart(e.target.value)}
                    />
                  </div>
                  <div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", gap: "5px", justifyContent: "flex-end" }}>
                    <label htmlFor="term_cash_value_perc" style={{ width: "max-content" }}>
                      % OF PREMIUM TOWARDS "CV"
                    </label>
                    <input
                      name="term_cash_value_perc"
                      type="number"
                      placeholder="% OF PREMIUM"
                      className="form-input-item"
                      style={{ width: "80px", textAlign: "right" }}
                      value={termCashValuePerc}
                      onChange={(e) => setTermCashValuePerc(e.target.value)}
                    />
                  </div>
                  <hr className="separator-h" />
                </div>
                <div className="overlay-content-left">
                  <div className="input-item-with-label">
                    <label htmlFor="death_cover" style={{ width: "100px" }}>
                      {t('mainCover').toUpperCase()}
                    </label>
                    <Select
                      id="death_cover"
                      name="death_cover"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={termCcCode}
                      onChange={(selectedOption) => {
                        try {
                          setTermMcCode(selectedOption?.mc_code);
                          setTermScCode(selectedOption?.sc_code);
                          setTermCcCode(selectedOption);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      options={deathCovers}
                      isSearchable={true}
                      placeholder={t('mainCover').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label htmlFor="rider" style={{ width: "100px" }}>
                      {t('mainRider').toUpperCase()}
                    </label>
                    <Select
                      id="rider"
                      name="rider"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={termRiderCode}
                      onChange={(selectedOption) => {
                        try {
                          setTermMcCode(selectedOption?.mc_code);
                          setTermScCode(selectedOption?.sc_code);
                          setTermRiderCode(selectedOption);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      options={deathCovers}
                      isSearchable={true}
                      placeholder={t('mainRider').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label" style={{ justifyContent: "flex-end" }} >
                    <ToggleSwitch
                      id="term_rider_trigger_cm"
                      value={termRiderTriggerCm}
                      onChange={setTermRiderTriggerCm}
                      label={t('triggerClaim').toUpperCase()}
                      labelWidth="max-content"
                      border="N"
                      style={{
                        width: "max-content",
                      }}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label htmlFor="term_death_level" style={{ width: "100px" }}>
                      {t('behavior').toUpperCase()}
                    </label>
                    <Select
                      id="term_death_level"
                      name="term_death_level"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={termDeathLevel}
                      onChange={(selectedOption) => {
                        try {
                          setTermDeathLevel(selectedOption);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      options={benefitLevels}
                      isSearchable={true}
                      placeholder={t('behavior').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label htmlFor="term_payment_freq" style={{ width: "100px" }}>
                      {t('premFreq').toUpperCase()}
                    </label>
                    <Select
                      id="term_payment_freq"
                      name="term_payment_freq"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={termPaymentFreq}
                      onChange={(selectedOption) => {
                        try {
                          setTermPaymentFreq(selectedOption);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      options={paymentFreqs}
                      isSearchable={true}
                      placeholder={t('level').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label htmlFor="joint_type" style={{ width: "100px" }}>
                      {t('jointType').toUpperCase()}
                    </label>
                    <Select
                      id="joint_type"
                      name="joint_type"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={termJointType}
                      onChange={(selectedOption) => {
                        try {
                          setTermJointType(selectedOption);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      options={jointTypes}
                      isSearchable={true}
                      placeholder={t('type').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label" style={{ justifyContent: "flex-end" }} >
                    <label htmlFor="joint_type" style={{ width: "100px" }}>
                      {t('mortality').toUpperCase()}
                    </label>
                    <Select
                      id="term_mo_code"
                      name="term_mo_code"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="240px"
                      value={termMoCode}
                      onChange={(selectedOption) => {
                        try {
                          setTermMoCode(selectedOption);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      options={mortalityTables}
                      isSearchable={true}
                      placeholder={t('mortalityTable').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label" style={{ justifyContent: "flex-end" }} >
                    <ToggleSwitch
                      id="term_medical"
                      value={termMedical}
                      onChange={setTermMedical}
                      label={t('medical').toUpperCase()}
                      labelWidth="max-content"
                      border="N"
                      style={{
                        width: "max-content",
                      }}
                    />
                    <Select
                      id="term_mr_code"
                      name="term_mr_code"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="240px"
                      value={termMrCode}
                      onChange={(selectedOption) => {
                        try {
                          setTermMrCode(selectedOption);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      options={medicalReviews}
                      isSearchable={true}
                      placeholder={t('medical').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "5px", marginLeft: "15px" }}>
                    <ToggleSwitch
                      id="term_renewable"
                      value={termRenewable}
                      onChange={setTermRenewable}
                      label={t('renewable').toUpperCase()}
                      labelWidth="max-content"
                      // disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                      border="N"
                      style={{
                        width: "max-content",
                      }}
                    />
                    <ToggleSwitch
                      id="term_enabled"
                      value={termEnabled}
                      onChange={setTermEnabled}
                      label={t('enabled').toUpperCase()}
                      labelWidth="max-content"
                      border="N"
                      style={{
                        width: "max-content",
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="overlay-actions">
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  onClick={handleProductTerm}
                  borderRadiusType="both"
                  variant="tint"
                  color="#00D37F"
                >
                  {termAction === "edit" ? t('update') : t('add').toUpperCase()}
                </CustomLoadingButton>
              </div>
            </div>
          </motion.div>
        )}
        {isNewConditionOpen && (
          <motion.div
            className="overlay-dialog"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
          >
            <div className="overlay-wrapper">
              <div className="overlay-navbar">
                <h1 className="main-title">
                  {objectToAction?.new_doc_status === "newDeductible"
                    ? t('addDeductible')
                    : objectToAction?.new_doc_status === "newCondition"
                      ? t('addCondition')
                      : objectToAction?.new_doc_status === "newCharge"
                        ? t('addCharge')
                        : t('add')}
                </h1>
                <CircularButton
                  currentTheme={currentTheme}
                  onClick={() => setIsNewConditionOpen(false)}
                  icon={<MdClose />}
                  width={"35px"}
                  height={"35px"} />
              </div>
              <div className="overlay-content">
                {objectToAction?.new_doc_status === "newCharge" &&
                  <div className="input-item-with-label">
                    <label
                      htmlFor="selectedCharge"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('charge').toUpperCase()}
                    </label>
                    <Select
                      id="selectedCharge"
                      name="selectedCharge"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={selectedCharge}
                      onChange={(selectedOption) => {
                        try {
                          setSelectedCharge(selectedOption);
                          setNewCode(selectedOption?.value);
                          setNewText(selectedOption?.label);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      options={charges}
                      isSearchable={true}
                      placeholder={t('select').toUpperCase()}
                    />
                  </div>}
              </div>
              <div className="overlay-actions">
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#00D37F"
                  tooltip={`${t('add')} ${selectedCharge?.label}`}
                  endIcon={<MdAdd />}
                  onClick={handleNewDedCondition}
                >
                  {t('add')}
                </CustomLoadingButton>
              </div>
            </div>
          </motion.div>
        )}

        {/* Dialog to notify user about changes being saved */}
        <Dialog open={isNotifyDialogOpen}
          onClose={() => setIsNotifyDialogOpen(false)}
          PaperProps={{
            sx: {
              backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
              color: currentTheme === "dark" ? "#fff" : "#000",
              minWidth: "300px",
              maxWidth: "500px",
            },
          }}
          slotProps={{
            backdrop: {
              sx: {
                backgroundColor: "rgba(0, 0, 0, 0.7)",
              },
            },
          }}>
          <DialogTitle>{notifyDialogTitle}</DialogTitle>
          <DialogContent>
            <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
          </DialogContent>
          <DialogActions>
            <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
          </DialogActions>
        </Dialog>
        {/* Confirm Dialog */}
        <ConfirmDialog
          isOpen={isConfirmDialogOpen}
          onClose={() => setIsConfirmDialogOpen(false)}
          onConfirm={handleConfirm}
          dialogTitle={t('confirmation')}
          dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
        />
        {isProcessing && (
          <motion.div
            className="processing-dialog"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
          >
            <div className="processing-wrapper">
              <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
              <ScaleLoader
                color="var(--primary)"
                height={50}
                radius={8}
                width={4}
              />
            </div>
          </motion.div>
        )}
        {isPreviewOpen && (
          <motion.div
            className="overlay-dialog"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
          >
            <div className="overlay-wrapper" style={{
              display: "flex",
              flexDirection: "column",
              width: "50%"
            }}>
              <div className="overlay-navbar">
                <h1 className="main-title">{t('preview').toUpperCase()}</h1>
                <CircularButton currentTheme={currentTheme} onClick={() => setIsPreviewOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
              </div>
              <div className="overlay-content">
                <span className="main-title">{t('email').toUpperCase()} {t('preview').toUpperCase()}</span>
                <div className="preview-email">
                  <div dangerouslySetInnerHTML={{ __html: previewEmailContent }} />
                </div>
                <span className="main-title">{t('sms').toUpperCase()} {t('preview').toUpperCase()}</span>
                <div className="preview-sms">
                  <div dangerouslySetInnerHTML={{ __html: previewSmsContent }} />
                </div>
                <span className="note-text">Please NOTE: All placeholders will be replaced with actual values when sending the email and/or SMS. Shown values are for display only</span>
              </div>
              <div className="overlay-actions">
              </div>
            </div>
          </motion.div>
        )}
        {isReportDialogOpen && (
          <motion.div
            className="overlay-dialog"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
          >
            <div className="overlay-wrapper">
              <div className="overlay-navbar">
                <span className="main-title">{`${currentAction === "addReport" ? t('addReport').toUpperCase() : t('editReport').toUpperCase()}`}</span>
                <CircularButton currentTheme={currentTheme} onClick={() => setIsReportDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
              </div>
              <div className="overlay-content">
                <div className="overlay-content">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="reportTitle"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('name').toUpperCase()}
                    </label>
                    <input
                      id="reportTitle"
                      name="reportTitle"
                      type="text"
                      placeholder={t('name').toUpperCase()}
                      value={reportTitle}
                      className="form-input-item"
                      style={{ width: "350px" }}
                      onChange={(e) => setReportTitle(e.target.value)}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="doc_type"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('type').toUpperCase()}
                    </label>
                    <Select
                      id="doc_type"
                      name="doc_type"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="350px"
                      value={selectedDocumentType}
                      onChange={(selectedOption) => setSelectedDocumentType(selectedOption)}
                      options={documentTypes}
                      isSearchable={true}
                      placeholder={t('type').toUpperCase()}
                    />
                  </div>

                  <div className="input-item-with-label">
                    <label
                      htmlFor="reportDesc"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('desc').toUpperCase()}
                    </label>
                    <textarea
                      id="reportDesc"
                      name="reportDesc"
                      type="text"
                      placeholder={t('desc').toUpperCase()}
                      value={reportDesc}
                      rows={2}
                      className="form-input-item"
                      style={{ width: "350px", height: "max-content" }}
                      onChange={(e) => setReportDesc(e.target.value)}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="reportFileName"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('file').toUpperCase()}
                    </label>
                    <input
                      id="reportFileName"
                      name="reportFileName"
                      type="text"
                      placeholder={t('file').toUpperCase()}
                      value={reportFileName}
                      className="form-input-item"
                      style={{ width: "350px" }}
                      onChange={(e) => setReportFileName(e.target.value)}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="reportEndpoint"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('endpoint').toUpperCase()}
                    </label>
                    <input
                      id="reportEndpoint"
                      name="reportEndpoint"
                      type="text"
                      placeholder={t('endpoint').toUpperCase()}
                      value={reportEndpoint}
                      className="form-input-item"
                      style={{ width: "350px" }}
                      onChange={(e) => setReportEndpoint(e.target.value)}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="report_tag"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('tag').toUpperCase()}
                    </label>
                    <Select
                      id="report_tag"
                      name="report_tag"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="350px"
                      value={reportTags.find((option) => option.value === reportTag?.value) || null}
                      onChange={(selectedOption) => setReportTag(selectedOption)}
                      options={reportTags}
                      isSearchable={true}
                      placeholder={t('tag').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="reportFilePath"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('icon').toUpperCase()}
                    </label>
                    <Select
                      id="icon_select"
                      name="icon_select"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      options={qilloIconOptions}
                      width="350px"
                      isSearchable={true}
                      placeholder={t('icon').toUpperCase()}
                      value={selectedIcon}
                      onChange={setSelectedIcon}
                      getOptionLabel={(e) => (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          {e.icon} {e.label}
                        </div>
                      )}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label htmlFor="report_format"
                      className="form-input-label"
                      style={{ width: "100px" }}>
                      {t('format').toUpperCase()}
                    </label>
                    <Select
                      id="report_format"
                      name="report_format"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="100px"
                      value={reportFormat}
                      onChange={(selectedOption) => setReportFormat(selectedOption)}
                      options={allowedFormats}
                      isSearchable={true}
                      placeholder={t('format').toUpperCase()}
                    />
                    <ToggleSwitch
                      id="report_format_change"
                      value={reportFormatChange}
                      onChange={setReportFormatChange}
                      label={t('allowFormatChange').toUpperCase()}
                      labelWidth="max-content"
                      labelPosition="end"
                      disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                      border="N"
                      style={{ width: "max-content" }}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label htmlFor="report_background"
                      className="form-dropdown-label"
                      style={{ width: "90px" }}
                    />
                    <ToggleSwitch
                      id="report_background"
                      value={reportBackground}
                      onChange={setReportBackground}
                      label={t('allowBackgroundRun').toUpperCase()}
                      labelWidth="max-content"
                      labelPosition="end"
                      disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                      border="N"
                      style={{ width: "max-content" }}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label htmlFor="reportEnabled"
                      className="form-dropdown-label"
                      style={{ width: "90px" }}
                    />
                    <ToggleSwitch
                      id="reportEnabled"
                      value={reportEnabled}
                      onChange={setReportEnabled}
                      label={t('enabled').toUpperCase()}
                      labelWidth="max-content"
                      labelPosition="end"
                      disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                      border="N"
                      style={{ width: "max-content" }}
                    />
                  </div>
                </div>
              </div>
              <div className="overlay-actions">
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  onClick={handleReportSubmit}
                  borderRadiusType="both"
                  variant="tint"
                  color="#2563EB"
                >
                  {currentAction === "addReport" ? t('add') : t('update')}
                </CustomLoadingButton>
              </div>
            </div>
          </motion.div>
        )}
        {isNewSmiDialogOpen && (
          <motion.div
            className="overlay-dialog"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
          >
            <div className="overlay-wrapper">
              <div className="overlay-navbar">
                <span className="main-title">{t('add').toUpperCase()}</span>
                <CircularButton currentTheme={currentTheme} onClick={() => setIsNewSmiDialogOpen(false)} icon={<MdClose />} width={"30px"} height={"30px"} />
              </div>
              <div className="overlay-content">
                <div className="overlay-content">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="newSmiName"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('name').toUpperCase()}
                    </label>
                    <input
                      ref={newSmiNameRef}
                      id="newSmiName"
                      name="newSmiName"
                      type="text"
                      placeholder={t('smiName').toUpperCase()}
                      value={newSmiName}
                      className="form-input-item"
                      style={{ width: "350px" }}
                      onChange={(e) => setNewSmiName(e.target.value)}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="newSmiCover"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('cover').toUpperCase()}
                    </label>
                    <Select
                      id="newSmiCover"
                      name="newSmiCover"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="350px"
                      value={newSmiCover}
                      onChange={(selectedOption) => setNewSmiCover(selectedOption)}
                      options={expressCovers}
                      isSearchable={true}
                      placeholder={t('cover').toUpperCase()}
                    />
                  </div>
                </div>
              </div>
              <div className="overlay-actions">
                <CustomLoadingButton
                  onClick={async (e) => {
                    try {

                      if (!newSmiName) {
                        setNotifyDialogTitle("Note!");
                        setNotifyDialogText(`Please enter smi name`);
                        setIsNotifyDialogOpen(true);
                        return;
                      }

                      if (!newSmiCover?.value) {
                        setNotifyDialogTitle("Note!");
                        setNotifyDialogText(`Please select cover`);
                        setIsNotifyDialogOpen(true);
                        return;
                      }

                      const expOrder = (expressSmis?.length || 0) + 1;

                      const res = await newRequest.post(
                        "/uwProduct/addExpressSmi",
                        {
                          exp_pr_code: prCode,
                          exp_mc_code: newSmiCover?.cc_mc_code,
                          exp_sc_code: newSmiCover?.cc_sc_code,
                          exp_cc_code: newSmiCover?.cc_code,
                          exp_smi_name: newSmiName,
                          exp_default_si: 0,
                          exp_rate: 0,
                          exp_rate_per: 100,
                          exp_premium: 0,
                          exp_fcl_value: 0,
                          exp_qty: 0,
                          exp_order: expOrder
                        }
                      );

                      if (res.data?.msg === "added") {
                        setExpressSmis((prevParams) => [...prevParams, res.data?.doc]);
                        setNewSmiName("");
                        setNewSmiCover(null);
                        showToast(t('added'), "success");
                        if (newSmiNameRef.current) {
                          newSmiNameRef.current?.focus();
                        }
                      } else {
                        showToast("Error adding SMI!", "error");
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}>
                  {t('add')}
                </CustomLoadingButton>
              </div>
            </div>
          </motion.div>
        )}
      </div >
    </motion.div >
  );
};

export default UwProduct;
